const api={
  fetch: ()=>new Promise(resolve=>resolve(/* [
    {
        "data": "2021-11-15",
        "origin": "COR",
        "destination": "MDZ",
        "price": 474.05,
        "availability": 9
    },
    {
        "data": "2021-11-15",
        "origin": "COR",
        "destination": "BRC",
        "price": 197.68,
        "availability": 2
    },
    {
        "data": "2021-11-15",
        "origin": "EPA",
        "destination": "BRC",
        "price": 300.3,
        "availability": 1
    },
    {
        "data": "2021-11-20",
        "origin": "COR",
        "destination": "MDZ",
        "price": 373.19,
        "availability": 6
    },
    {
        "data": "2021-11-20",
        "origin": "COR",
        "destination": "BRC",
        "price": 191.74,
        "availability": 7
    },
    {
        "data": "2021-11-20",
        "origin": "EPA",
        "destination": "BRC",
        "price": 215.89,
        "availability": 8
    },
    {
        "data": "2021-11-16",
        "origin": "COR",
        "destination": "MDZ",
        "price": 498.97,
        "availability": 2
    },
    {
        "data": "2021-11-16",
        "origin": "COR",
        "destination": "BRC",
        "price": 327.07,
        "availability": 6
    },
    {
        "data": "2021-11-16",
        "origin": "EPA",
        "destination": "BRC",
        "price": 335.29,
        "availability": 5
    },
    {
        "data": "2021-11-19",
        "origin": "COR",
        "destination": "MDZ",
        "price": 284.86,
        "availability": 1
    },
    {
        "data": "2021-11-19",
        "origin": "COR",
        "destination": "BRC",
        "price": 399.34,
        "availability": 9
    },
    {
        "data": "2021-11-19",
        "origin": "EPA",
        "destination": "BRC",
        "price": 459.26,
        "availability": 9
    },
    {
        "data": "2021-11-26",
        "origin": "COR",
        "destination": "MDZ",
        "price": 168.63,
        "availability": 8
    },
    {
        "data": "2021-11-26",
        "origin": "COR",
        "destination": "BRC",
        "price": 204.47,
        "availability": 9
    },
    {
        "data": "2021-11-26",
        "origin": "EPA",
        "destination": "BRC",
        "price": 440.26,
        "availability": 5
    },
    {
        "data": "2021-11-21",
        "origin": "COR",
        "destination": "MDZ",
        "price": 277.06,
        "availability": 3
    },
    {
        "data": "2021-11-21",
        "origin": "COR",
        "destination": "BRC",
        "price": 453.05,
        "availability": 5
    },
    {
        "data": "2021-11-21",
        "origin": "EPA",
        "destination": "BRC",
        "price": 213.52,
        "availability": 7
    },
    {
        "data": "2021-11-17",
        "origin": "COR",
        "destination": "MDZ",
        "price": 298.25,
        "availability": 4
    },
    {
        "data": "2021-11-17",
        "origin": "COR",
        "destination": "BRC",
        "price": 352.73,
        "availability": 6
    },
    {
        "data": "2021-11-17",
        "origin": "EPA",
        "destination": "BRC",
        "price": 336.71,
        "availability": 4
    },
    {
        "data": "2021-11-18",
        "origin": "COR",
        "destination": "MDZ",
        "price": 229.48,
        "availability": 2
    },
    {
        "data": "2021-11-18",
        "origin": "COR",
        "destination": "BRC",
        "price": 483.83,
        "availability": 2
    },
    {
        "data": "2021-11-18",
        "origin": "EPA",
        "destination": "BRC",
        "price": 252.05,
        "availability": 6
    },
    {
        "data": "2021-11-27",
        "origin": "COR",
        "destination": "MDZ",
        "price": 287.99,
        "availability": 3
    },
    {
        "data": "2021-11-27",
        "origin": "COR",
        "destination": "BRC",
        "price": 401.16,
        "availability": 4
    },
    {
        "data": "2021-11-27",
        "origin": "EPA",
        "destination": "BRC",
        "price": 390.96,
        "availability": 5
    },
    {
        "data": "2021-11-28",
        "origin": "COR",
        "destination": "MDZ",
        "price": 357,
        "availability": 3
    },
    {
        "data": "2021-11-28",
        "origin": "COR",
        "destination": "BRC",
        "price": 162.85,
        "availability": 4
    },
    {
        "data": "2021-11-28",
        "origin": "EPA",
        "destination": "BRC",
        "price": 196.39,
        "availability": 5
    },
    {
        "data": "2021-11-25",
        "origin": "COR",
        "destination": "MDZ",
        "price": 492.82,
        "availability": 6
    },
    {
        "data": "2021-11-25",
        "origin": "COR",
        "destination": "BRC",
        "price": 435.74,
        "availability": 9
    },
    {
        "data": "2021-11-25",
        "origin": "EPA",
        "destination": "BRC",
        "price": 354.13,
        "availability": 3
    },
    {
        "data": "2021-11-23",
        "origin": "COR",
        "destination": "MDZ",
        "price": 335.83,
        "availability": 2
    },
    {
        "data": "2021-11-23",
        "origin": "COR",
        "destination": "BRC",
        "price": 407.09,
        "availability": 3
    },
    {
        "data": "2021-11-23",
        "origin": "EPA",
        "destination": "BRC",
        "price": 319.94,
        "availability": 3
    },
    {
        "data": "2021-12-03",
        "origin": "COR",
        "destination": "MDZ",
        "price": 417.6,
        "availability": 1
    },
    {
        "data": "2021-12-03",
        "origin": "COR",
        "destination": "BRC",
        "price": 415.8,
        "availability": 2
    },
    {
        "data": "2021-12-03",
        "origin": "EPA",
        "destination": "BRC",
        "price": 390.77,
        "availability": 7
    },
    {
        "data": "2021-11-30",
        "origin": "COR",
        "destination": "MDZ",
        "price": 290.93,
        "availability": 2
    },
    {
        "data": "2021-11-30",
        "origin": "COR",
        "destination": "BRC",
        "price": 289.3,
        "availability": 4
    },
    {
        "data": "2021-11-30",
        "origin": "EPA",
        "destination": "BRC",
        "price": 196.18,
        "availability": 3
    },
    {
        "data": "2021-11-24",
        "origin": "COR",
        "destination": "MDZ",
        "price": 203.56,
        "availability": 8
    },
    {
        "data": "2021-11-24",
        "origin": "COR",
        "destination": "BRC",
        "price": 364.48,
        "availability": 6
    },
    {
        "data": "2021-11-24",
        "origin": "EPA",
        "destination": "BRC",
        "price": 335.77,
        "availability": 9
    },
    {
        "data": "2021-11-22",
        "origin": "COR",
        "destination": "MDZ",
        "price": 456.26,
        "availability": 7
    },
    {
        "data": "2021-11-22",
        "origin": "COR",
        "destination": "BRC",
        "price": 395.67,
        "availability": 7
    },
    {
        "data": "2021-11-22",
        "origin": "EPA",
        "destination": "BRC",
        "price": 448.25,
        "availability": 3
    },
    {
        "data": "2021-12-02",
        "origin": "COR",
        "destination": "MDZ",
        "price": 270.12,
        "availability": 3
    },
    {
        "data": "2021-12-02",
        "origin": "COR",
        "destination": "BRC",
        "price": 345.12,
        "availability": 9
    },
    {
        "data": "2021-12-02",
        "origin": "EPA",
        "destination": "BRC",
        "price": 434.13,
        "availability": 6
    },
    {
        "data": "2021-12-04",
        "origin": "COR",
        "destination": "MDZ",
        "price": 299.28,
        "availability": 4
    },
    {
        "data": "2021-12-04",
        "origin": "COR",
        "destination": "BRC",
        "price": 433.98,
        "availability": 9
    },
    {
        "data": "2021-12-04",
        "origin": "EPA",
        "destination": "BRC",
        "price": 373.12,
        "availability": 6
    },
    {
        "data": "2021-11-29",
        "origin": "COR",
        "destination": "MDZ",
        "price": 327.93,
        "availability": 5
    },
    {
        "data": "2021-11-29",
        "origin": "COR",
        "destination": "BRC",
        "price": 448.2,
        "availability": 2
    },
    {
        "data": "2021-11-29",
        "origin": "EPA",
        "destination": "BRC",
        "price": 433.94,
        "availability": 8
    },
    {
        "data": "2021-12-06",
        "origin": "COR",
        "destination": "MDZ",
        "price": 341.23,
        "availability": 6
    },
    {
        "data": "2021-12-06",
        "origin": "COR",
        "destination": "BRC",
        "price": 415.79,
        "availability": 3
    },
    {
        "data": "2021-12-06",
        "origin": "EPA",
        "destination": "BRC",
        "price": 164.21,
        "availability": 8
    },
    {
        "data": "2021-12-12",
        "origin": "COR",
        "destination": "MDZ",
        "price": 416.69,
        "availability": 6
    },
    {
        "data": "2021-12-12",
        "origin": "COR",
        "destination": "BRC",
        "price": 442.13,
        "availability": 6
    },
    {
        "data": "2021-12-12",
        "origin": "EPA",
        "destination": "BRC",
        "price": 188.68,
        "availability": 6
    },
    {
        "data": "2021-12-05",
        "origin": "COR",
        "destination": "MDZ",
        "price": 391.23,
        "availability": 5
    },
    {
        "data": "2021-12-05",
        "origin": "COR",
        "destination": "BRC",
        "price": 279.98,
        "availability": 8
    },
    {
        "data": "2021-12-05",
        "origin": "EPA",
        "destination": "BRC",
        "price": 222.73,
        "availability": 4
    },
    {
        "data": "2021-12-11",
        "origin": "COR",
        "destination": "MDZ",
        "price": 261.96,
        "availability": 7
    },
    {
        "data": "2021-12-11",
        "origin": "COR",
        "destination": "BRC",
        "price": 403.83,
        "availability": 5
    },
    {
        "data": "2021-12-11",
        "origin": "EPA",
        "destination": "BRC",
        "price": 187.81,
        "availability": 4
    },
    {
        "data": "2021-12-07",
        "origin": "COR",
        "destination": "MDZ",
        "price": 417.33,
        "availability": 7
    },
    {
        "data": "2022-04-23",
        "origin": "MDZ",
        "destination": "COR",
        "price": 271.38,
        "availability": 7
    }
] */
[
    {
        "data": "2021-11-15",
        "origin": "COR",
        "destination": "MDZ",
        "price": 474.05,
        "availability": 9
    },
    {
        "data": "2021-11-15",
        "origin": "COR",
        "destination": "BRC",
        "price": 197.68,
        "availability": 2
    },
    {
        "data": "2021-11-15",
        "origin": "EPA",
        "destination": "BRC",
        "price": 300.3,
        "availability": 1
    },
    {
        "data": "2021-11-20",
        "origin": "COR",
        "destination": "MDZ",
        "price": 373.19,
        "availability": 6
    },
    {
        "data": "2021-11-20",
        "origin": "COR",
        "destination": "BRC",
        "price": 191.74,
        "availability": 7
    },
    {
        "data": "2021-11-20",
        "origin": "EPA",
        "destination": "BRC",
        "price": 215.89,
        "availability": 8
    },
    {
        "data": "2021-11-16",
        "origin": "COR",
        "destination": "MDZ",
        "price": 498.97,
        "availability": 2
    },
    {
        "data": "2021-11-16",
        "origin": "COR",
        "destination": "BRC",
        "price": 327.07,
        "availability": 6
    },
    {
        "data": "2021-11-16",
        "origin": "EPA",
        "destination": "BRC",
        "price": 335.29,
        "availability": 5
    },
    {
        "data": "2021-11-19",
        "origin": "COR",
        "destination": "MDZ",
        "price": 284.86,
        "availability": 1
    },
    {
        "data": "2021-11-19",
        "origin": "COR",
        "destination": "BRC",
        "price": 399.34,
        "availability": 9
    },
    {
        "data": "2021-11-19",
        "origin": "EPA",
        "destination": "BRC",
        "price": 459.26,
        "availability": 9
    },
    {
        "data": "2021-11-26",
        "origin": "COR",
        "destination": "MDZ",
        "price": 168.63,
        "availability": 8
    },
    {
        "data": "2021-11-26",
        "origin": "COR",
        "destination": "BRC",
        "price": 204.47,
        "availability": 9
    },
    {
        "data": "2021-11-26",
        "origin": "EPA",
        "destination": "BRC",
        "price": 440.26,
        "availability": 5
    },
    {
        "data": "2021-11-21",
        "origin": "COR",
        "destination": "MDZ",
        "price": 277.06,
        "availability": 3
    },
    {
        "data": "2021-11-21",
        "origin": "COR",
        "destination": "BRC",
        "price": 453.05,
        "availability": 5
    },
    {
        "data": "2021-11-21",
        "origin": "EPA",
        "destination": "BRC",
        "price": 213.52,
        "availability": 7
    },
    {
        "data": "2021-11-17",
        "origin": "COR",
        "destination": "MDZ",
        "price": 298.25,
        "availability": 4
    },
    {
        "data": "2021-11-17",
        "origin": "COR",
        "destination": "BRC",
        "price": 352.73,
        "availability": 6
    },
    {
        "data": "2021-11-17",
        "origin": "EPA",
        "destination": "BRC",
        "price": 336.71,
        "availability": 4
    },
    {
        "data": "2021-11-18",
        "origin": "COR",
        "destination": "MDZ",
        "price": 229.48,
        "availability": 2
    },
    {
        "data": "2021-11-18",
        "origin": "COR",
        "destination": "BRC",
        "price": 483.83,
        "availability": 2
    },
    {
        "data": "2021-11-18",
        "origin": "EPA",
        "destination": "BRC",
        "price": 252.05,
        "availability": 6
    },
    {
        "data": "2021-11-27",
        "origin": "COR",
        "destination": "MDZ",
        "price": 287.99,
        "availability": 3
    },
    {
        "data": "2021-11-27",
        "origin": "COR",
        "destination": "BRC",
        "price": 401.16,
        "availability": 4
    },
    {
        "data": "2021-11-27",
        "origin": "EPA",
        "destination": "BRC",
        "price": 390.96,
        "availability": 5
    },
    {
        "data": "2021-11-28",
        "origin": "COR",
        "destination": "MDZ",
        "price": 357,
        "availability": 3
    },
    {
        "data": "2021-11-28",
        "origin": "COR",
        "destination": "BRC",
        "price": 162.85,
        "availability": 4
    },
    {
        "data": "2021-11-28",
        "origin": "EPA",
        "destination": "BRC",
        "price": 196.39,
        "availability": 5
    },
    {
        "data": "2021-11-25",
        "origin": "COR",
        "destination": "MDZ",
        "price": 492.82,
        "availability": 6
    },
    {
        "data": "2021-11-25",
        "origin": "COR",
        "destination": "BRC",
        "price": 435.74,
        "availability": 9
    },
    {
        "data": "2021-11-25",
        "origin": "EPA",
        "destination": "BRC",
        "price": 354.13,
        "availability": 3
    },
    {
        "data": "2021-11-23",
        "origin": "COR",
        "destination": "MDZ",
        "price": 335.83,
        "availability": 2
    },
    {
        "data": "2021-11-23",
        "origin": "COR",
        "destination": "BRC",
        "price": 407.09,
        "availability": 3
    },
    {
        "data": "2021-11-23",
        "origin": "EPA",
        "destination": "BRC",
        "price": 319.94,
        "availability": 3
    },
    {
        "data": "2021-12-03",
        "origin": "COR",
        "destination": "MDZ",
        "price": 417.6,
        "availability": 1
    },
    {
        "data": "2021-12-03",
        "origin": "COR",
        "destination": "BRC",
        "price": 415.8,
        "availability": 2
    },
    {
        "data": "2021-12-03",
        "origin": "EPA",
        "destination": "BRC",
        "price": 390.77,
        "availability": 7
    },
    {
        "data": "2021-11-30",
        "origin": "COR",
        "destination": "MDZ",
        "price": 290.93,
        "availability": 2
    },
    {
        "data": "2021-11-30",
        "origin": "COR",
        "destination": "BRC",
        "price": 289.3,
        "availability": 4
    },
    {
        "data": "2021-11-30",
        "origin": "EPA",
        "destination": "BRC",
        "price": 196.18,
        "availability": 3
    },
    {
        "data": "2021-11-24",
        "origin": "COR",
        "destination": "MDZ",
        "price": 203.56,
        "availability": 8
    },
    {
        "data": "2021-11-24",
        "origin": "COR",
        "destination": "BRC",
        "price": 364.48,
        "availability": 6
    },
    {
        "data": "2021-11-24",
        "origin": "EPA",
        "destination": "BRC",
        "price": 335.77,
        "availability": 9
    },
    {
        "data": "2021-11-22",
        "origin": "COR",
        "destination": "MDZ",
        "price": 456.26,
        "availability": 7
    },
    {
        "data": "2021-11-22",
        "origin": "COR",
        "destination": "BRC",
        "price": 395.67,
        "availability": 7
    },
    {
        "data": "2021-11-22",
        "origin": "EPA",
        "destination": "BRC",
        "price": 448.25,
        "availability": 3
    },
    {
        "data": "2021-12-02",
        "origin": "COR",
        "destination": "MDZ",
        "price": 270.12,
        "availability": 3
    },
    {
        "data": "2021-12-02",
        "origin": "COR",
        "destination": "BRC",
        "price": 345.12,
        "availability": 9
    },
    {
        "data": "2021-12-02",
        "origin": "EPA",
        "destination": "BRC",
        "price": 434.13,
        "availability": 6
    },
    {
        "data": "2021-12-04",
        "origin": "COR",
        "destination": "MDZ",
        "price": 299.28,
        "availability": 4
    },
    {
        "data": "2021-12-04",
        "origin": "COR",
        "destination": "BRC",
        "price": 433.98,
        "availability": 9
    },
    {
        "data": "2021-12-04",
        "origin": "EPA",
        "destination": "BRC",
        "price": 373.12,
        "availability": 6
    },
    {
        "data": "2021-11-29",
        "origin": "COR",
        "destination": "MDZ",
        "price": 327.93,
        "availability": 5
    },
    {
        "data": "2021-11-29",
        "origin": "COR",
        "destination": "BRC",
        "price": 448.2,
        "availability": 2
    },
    {
        "data": "2021-11-29",
        "origin": "EPA",
        "destination": "BRC",
        "price": 433.94,
        "availability": 8
    },
    {
        "data": "2021-12-06",
        "origin": "COR",
        "destination": "MDZ",
        "price": 341.23,
        "availability": 6
    },
    {
        "data": "2021-12-06",
        "origin": "COR",
        "destination": "BRC",
        "price": 415.79,
        "availability": 3
    },
    {
        "data": "2021-12-06",
        "origin": "EPA",
        "destination": "BRC",
        "price": 164.21,
        "availability": 8
    },
    {
        "data": "2021-12-12",
        "origin": "COR",
        "destination": "MDZ",
        "price": 416.69,
        "availability": 6
    },
    {
        "data": "2021-12-12",
        "origin": "COR",
        "destination": "BRC",
        "price": 442.13,
        "availability": 6
    },
    {
        "data": "2021-12-12",
        "origin": "EPA",
        "destination": "BRC",
        "price": 188.68,
        "availability": 6
    },
    {
        "data": "2021-12-05",
        "origin": "COR",
        "destination": "MDZ",
        "price": 391.23,
        "availability": 5
    },
    {
        "data": "2021-12-05",
        "origin": "COR",
        "destination": "BRC",
        "price": 279.98,
        "availability": 8
    },
    {
        "data": "2021-12-05",
        "origin": "EPA",
        "destination": "BRC",
        "price": 222.73,
        "availability": 4
    },
    {
        "data": "2021-12-11",
        "origin": "COR",
        "destination": "MDZ",
        "price": 261.96,
        "availability": 7
    },
    {
        "data": "2021-12-11",
        "origin": "COR",
        "destination": "BRC",
        "price": 403.83,
        "availability": 5
    },
    {
        "data": "2021-12-11",
        "origin": "EPA",
        "destination": "BRC",
        "price": 187.81,
        "availability": 4
    },
    {
        "data": "2021-12-07",
        "origin": "COR",
        "destination": "MDZ",
        "price": 417.33,
        "availability": 2
    },
    {
        "data": "2021-12-07",
        "origin": "COR",
        "destination": "BRC",
        "price": 414.04,
        "availability": 4
    },
    {
        "data": "2021-12-07",
        "origin": "EPA",
        "destination": "BRC",
        "price": 402.36,
        "availability": 3
    },
    {
        "data": "2021-12-13",
        "origin": "COR",
        "destination": "MDZ",
        "price": 432.29,
        "availability": 3
    },
    {
        "data": "2021-12-13",
        "origin": "COR",
        "destination": "BRC",
        "price": 296.15,
        "availability": 5
    },
    {
        "data": "2021-12-13",
        "origin": "EPA",
        "destination": "BRC",
        "price": 406.01,
        "availability": 2
    },
    {
        "data": "2021-12-08",
        "origin": "COR",
        "destination": "MDZ",
        "price": 226.38,
        "availability": 7
    },
    {
        "data": "2021-12-08",
        "origin": "COR",
        "destination": "BRC",
        "price": 232.95,
        "availability": 2
    },
    {
        "data": "2021-12-08",
        "origin": "EPA",
        "destination": "BRC",
        "price": 156.73,
        "availability": 7
    },
    {
        "data": "2021-12-01",
        "origin": "COR",
        "destination": "MDZ",
        "price": 375.78,
        "availability": 4
    },
    {
        "data": "2021-12-01",
        "origin": "COR",
        "destination": "BRC",
        "price": 214.08,
        "availability": 7
    },
    {
        "data": "2021-12-01",
        "origin": "EPA",
        "destination": "BRC",
        "price": 326.67,
        "availability": 3
    },
    {
        "data": "2021-12-17",
        "origin": "COR",
        "destination": "MDZ",
        "price": 292.02,
        "availability": 7
    },
    {
        "data": "2021-12-17",
        "origin": "COR",
        "destination": "BRC",
        "price": 376.21,
        "availability": 5
    },
    {
        "data": "2021-12-17",
        "origin": "EPA",
        "destination": "BRC",
        "price": 207.88,
        "availability": 9
    },
    {
        "data": "2021-12-21",
        "origin": "COR",
        "destination": "MDZ",
        "price": 196.49,
        "availability": 8
    },
    {
        "data": "2021-12-21",
        "origin": "COR",
        "destination": "BRC",
        "price": 396.9,
        "availability": 7
    },
    {
        "data": "2021-12-21",
        "origin": "EPA",
        "destination": "BRC",
        "price": 224.62,
        "availability": 4
    },
    {
        "data": "2021-12-09",
        "origin": "COR",
        "destination": "MDZ",
        "price": 335.94,
        "availability": 3
    },
    {
        "data": "2021-12-09",
        "origin": "COR",
        "destination": "BRC",
        "price": 473.09,
        "availability": 1
    },
    {
        "data": "2021-12-09",
        "origin": "EPA",
        "destination": "BRC",
        "price": 368.3,
        "availability": 4
    },
    {
        "data": "2021-12-23",
        "origin": "COR",
        "destination": "MDZ",
        "price": 266.02,
        "availability": 1
    },
    {
        "data": "2021-12-23",
        "origin": "COR",
        "destination": "BRC",
        "price": 455.07,
        "availability": 1
    },
    {
        "data": "2021-12-23",
        "origin": "EPA",
        "destination": "BRC",
        "price": 394.3,
        "availability": 4
    },
    {
        "data": "2021-12-16",
        "origin": "COR",
        "destination": "MDZ",
        "price": 197.38,
        "availability": 2
    },
    {
        "data": "2021-12-16",
        "origin": "COR",
        "destination": "BRC",
        "price": 387.25,
        "availability": 8
    },
    {
        "data": "2021-12-16",
        "origin": "EPA",
        "destination": "BRC",
        "price": 230.1,
        "availability": 9
    },
    {
        "data": "2021-12-20",
        "origin": "COR",
        "destination": "MDZ",
        "price": 269.71,
        "availability": 1
    },
    {
        "data": "2021-12-20",
        "origin": "COR",
        "destination": "BRC",
        "price": 468.44,
        "availability": 4
    },
    {
        "data": "2021-12-20",
        "origin": "EPA",
        "destination": "BRC",
        "price": 328.71,
        "availability": 5
    },
    {
        "data": "2021-12-15",
        "origin": "COR",
        "destination": "MDZ",
        "price": 306.84,
        "availability": 4
    },
    {
        "data": "2021-12-15",
        "origin": "COR",
        "destination": "BRC",
        "price": 262.49,
        "availability": 7
    },
    {
        "data": "2021-12-15",
        "origin": "EPA",
        "destination": "BRC",
        "price": 407.2,
        "availability": 7
    },
    {
        "data": "2021-12-10",
        "origin": "COR",
        "destination": "MDZ",
        "price": 202.48,
        "availability": 7
    },
    {
        "data": "2021-12-10",
        "origin": "COR",
        "destination": "BRC",
        "price": 152.68,
        "availability": 5
    },
    {
        "data": "2021-12-10",
        "origin": "EPA",
        "destination": "BRC",
        "price": 435.9,
        "availability": 4
    },
    {
        "data": "2021-12-24",
        "origin": "COR",
        "destination": "MDZ",
        "price": 488.91,
        "availability": 5
    },
    {
        "data": "2021-12-24",
        "origin": "COR",
        "destination": "BRC",
        "price": 267.7,
        "availability": 3
    },
    {
        "data": "2021-12-24",
        "origin": "EPA",
        "destination": "BRC",
        "price": 279.36,
        "availability": 9
    },
    {
        "data": "2022-01-07",
        "origin": "COR",
        "destination": "MDZ",
        "price": 276.11,
        "availability": 9
    },
    {
        "data": "2022-01-07",
        "origin": "COR",
        "destination": "BRC",
        "price": 293.47,
        "availability": 9
    },
    {
        "data": "2022-01-07",
        "origin": "EPA",
        "destination": "BRC",
        "price": 409.17,
        "availability": 3
    },
    {
        "data": "2021-12-14",
        "origin": "COR",
        "destination": "MDZ",
        "price": 374.24,
        "availability": 3
    },
    {
        "data": "2021-12-14",
        "origin": "COR",
        "destination": "BRC",
        "price": 306.45,
        "availability": 5
    },
    {
        "data": "2021-12-14",
        "origin": "EPA",
        "destination": "BRC",
        "price": 483.94,
        "availability": 1
    },
    {
        "data": "2022-01-04",
        "origin": "COR",
        "destination": "MDZ",
        "price": 451.19,
        "availability": 3
    },
    {
        "data": "2022-01-04",
        "origin": "COR",
        "destination": "BRC",
        "price": 234.3,
        "availability": 8
    },
    {
        "data": "2022-01-04",
        "origin": "EPA",
        "destination": "BRC",
        "price": 174.9,
        "availability": 5
    },
    {
        "data": "2021-12-25",
        "origin": "COR",
        "destination": "MDZ",
        "price": 470.91,
        "availability": 6
    },
    {
        "data": "2021-12-25",
        "origin": "COR",
        "destination": "BRC",
        "price": 273.17,
        "availability": 5
    },
    {
        "data": "2021-12-25",
        "origin": "EPA",
        "destination": "BRC",
        "price": 479.43,
        "availability": 7
    },
    {
        "data": "2022-01-06",
        "origin": "COR",
        "destination": "MDZ",
        "price": 399.61,
        "availability": 4
    },
    {
        "data": "2022-01-06",
        "origin": "COR",
        "destination": "BRC",
        "price": 362.84,
        "availability": 4
    },
    {
        "data": "2022-01-06",
        "origin": "EPA",
        "destination": "BRC",
        "price": 423.81,
        "availability": 2
    },
    {
        "data": "2021-12-19",
        "origin": "COR",
        "destination": "MDZ",
        "price": 425.81,
        "availability": 7
    },
    {
        "data": "2021-12-19",
        "origin": "COR",
        "destination": "BRC",
        "price": 466.2,
        "availability": 2
    },
    {
        "data": "2021-12-19",
        "origin": "EPA",
        "destination": "BRC",
        "price": 397.24,
        "availability": 8
    },
    {
        "data": "2021-12-22",
        "origin": "COR",
        "destination": "MDZ",
        "price": 407.8,
        "availability": 2
    },
    {
        "data": "2021-12-22",
        "origin": "COR",
        "destination": "BRC",
        "price": 164.07,
        "availability": 6
    },
    {
        "data": "2021-12-22",
        "origin": "EPA",
        "destination": "BRC",
        "price": 268.69,
        "availability": 5
    },
    {
        "data": "2021-12-28",
        "origin": "COR",
        "destination": "MDZ",
        "price": 363.38,
        "availability": 5
    },
    {
        "data": "2021-12-28",
        "origin": "COR",
        "destination": "BRC",
        "price": 423.93,
        "availability": 1
    },
    {
        "data": "2021-12-28",
        "origin": "EPA",
        "destination": "BRC",
        "price": 282.32,
        "availability": 7
    },
    {
        "data": "2022-01-16",
        "origin": "COR",
        "destination": "MDZ",
        "price": 288.29,
        "availability": 6
    },
    {
        "data": "2022-01-16",
        "origin": "COR",
        "destination": "BRC",
        "price": 228.79,
        "availability": 6
    },
    {
        "data": "2022-01-16",
        "origin": "EPA",
        "destination": "BRC",
        "price": 404.6,
        "availability": 2
    },
    {
        "data": "2021-12-18",
        "origin": "COR",
        "destination": "MDZ",
        "price": 262.17,
        "availability": 4
    },
    {
        "data": "2021-12-18",
        "origin": "COR",
        "destination": "BRC",
        "price": 214.09,
        "availability": 6
    },
    {
        "data": "2021-12-18",
        "origin": "EPA",
        "destination": "BRC",
        "price": 226.23,
        "availability": 5
    },
    {
        "data": "2022-01-15",
        "origin": "COR",
        "destination": "MDZ",
        "price": 240.97,
        "availability": 2
    },
    {
        "data": "2022-01-15",
        "origin": "COR",
        "destination": "BRC",
        "price": 481.71,
        "availability": 9
    },
    {
        "data": "2022-01-15",
        "origin": "EPA",
        "destination": "BRC",
        "price": 317.22,
        "availability": 3
    },
    {
        "data": "2021-12-29",
        "origin": "COR",
        "destination": "MDZ",
        "price": 348.44,
        "availability": 1
    },
    {
        "data": "2021-12-29",
        "origin": "COR",
        "destination": "BRC",
        "price": 227.04,
        "availability": 5
    },
    {
        "data": "2021-12-29",
        "origin": "EPA",
        "destination": "BRC",
        "price": 450.37,
        "availability": 3
    },
    {
        "data": "2022-01-17",
        "origin": "COR",
        "destination": "MDZ",
        "price": 302.03,
        "availability": 4
    },
    {
        "data": "2022-01-17",
        "origin": "COR",
        "destination": "BRC",
        "price": 337.36,
        "availability": 2
    },
    {
        "data": "2022-01-17",
        "origin": "EPA",
        "destination": "BRC",
        "price": 156.05,
        "availability": 1
    },
    {
        "data": "2021-12-27",
        "origin": "COR",
        "destination": "MDZ",
        "price": 364.98,
        "availability": 9
    },
    {
        "data": "2021-12-27",
        "origin": "COR",
        "destination": "BRC",
        "price": 249.73,
        "availability": 1
    },
    {
        "data": "2021-12-27",
        "origin": "EPA",
        "destination": "BRC",
        "price": 475.98,
        "availability": 4
    },
    {
        "data": "2022-01-05",
        "origin": "COR",
        "destination": "MDZ",
        "price": 424.15,
        "availability": 6
    },
    {
        "data": "2022-01-05",
        "origin": "COR",
        "destination": "BRC",
        "price": 204.31,
        "availability": 2
    },
    {
        "data": "2022-01-05",
        "origin": "EPA",
        "destination": "BRC",
        "price": 367.6,
        "availability": 5
    },
    {
        "data": "2021-12-31",
        "origin": "COR",
        "destination": "MDZ",
        "price": 433.53,
        "availability": 4
    },
    {
        "data": "2021-12-31",
        "origin": "COR",
        "destination": "BRC",
        "price": 469.08,
        "availability": 2
    },
    {
        "data": "2021-12-31",
        "origin": "EPA",
        "destination": "BRC",
        "price": 192.66,
        "availability": 8
    },
    {
        "data": "2022-01-24",
        "origin": "COR",
        "destination": "MDZ",
        "price": 184.52,
        "availability": 3
    },
    {
        "data": "2022-01-24",
        "origin": "COR",
        "destination": "BRC",
        "price": 446.64,
        "availability": 4
    },
    {
        "data": "2022-01-24",
        "origin": "EPA",
        "destination": "BRC",
        "price": 170.6,
        "availability": 5
    },
    {
        "data": "2021-12-26",
        "origin": "COR",
        "destination": "MDZ",
        "price": 422.3,
        "availability": 5
    },
    {
        "data": "2021-12-26",
        "origin": "COR",
        "destination": "BRC",
        "price": 345.29,
        "availability": 6
    },
    {
        "data": "2021-12-26",
        "origin": "EPA",
        "destination": "BRC",
        "price": 359.05,
        "availability": 2
    },
    {
        "data": "2022-01-26",
        "origin": "COR",
        "destination": "MDZ",
        "price": 177.32,
        "availability": 1
    },
    {
        "data": "2022-01-26",
        "origin": "COR",
        "destination": "BRC",
        "price": 323.24,
        "availability": 3
    },
    {
        "data": "2022-01-26",
        "origin": "EPA",
        "destination": "BRC",
        "price": 356.54,
        "availability": 7
    },
    {
        "data": "2021-12-30",
        "origin": "COR",
        "destination": "MDZ",
        "price": 482.47,
        "availability": 2
    },
    {
        "data": "2021-12-30",
        "origin": "COR",
        "destination": "BRC",
        "price": 199.83,
        "availability": 1
    },
    {
        "data": "2021-12-30",
        "origin": "EPA",
        "destination": "BRC",
        "price": 260.33,
        "availability": 3
    },
    {
        "data": "2022-01-25",
        "origin": "COR",
        "destination": "MDZ",
        "price": 263.03,
        "availability": 7
    },
    {
        "data": "2022-01-25",
        "origin": "COR",
        "destination": "BRC",
        "price": 314.09,
        "availability": 5
    },
    {
        "data": "2022-01-25",
        "origin": "EPA",
        "destination": "BRC",
        "price": 176.48,
        "availability": 1
    },
    {
        "data": "2022-01-02",
        "origin": "COR",
        "destination": "MDZ",
        "price": 291.01,
        "availability": 4
    },
    {
        "data": "2022-01-02",
        "origin": "COR",
        "destination": "BRC",
        "price": 216.01,
        "availability": 4
    },
    {
        "data": "2022-01-02",
        "origin": "EPA",
        "destination": "BRC",
        "price": 191.57,
        "availability": 6
    },
    {
        "data": "2022-01-14",
        "origin": "COR",
        "destination": "MDZ",
        "price": 331.55,
        "availability": 6
    },
    {
        "data": "2022-01-14",
        "origin": "COR",
        "destination": "BRC",
        "price": 414.46,
        "availability": 1
    },
    {
        "data": "2022-01-14",
        "origin": "EPA",
        "destination": "BRC",
        "price": 276.56,
        "availability": 2
    },
    {
        "data": "2022-01-01",
        "origin": "COR",
        "destination": "MDZ",
        "price": 249.57,
        "availability": 1
    },
    {
        "data": "2022-01-01",
        "origin": "COR",
        "destination": "BRC",
        "price": 154.23,
        "availability": 6
    },
    {
        "data": "2022-01-01",
        "origin": "EPA",
        "destination": "BRC",
        "price": 469.28,
        "availability": 1
    },
    {
        "data": "2022-02-05",
        "origin": "COR",
        "destination": "MDZ",
        "price": 487.48,
        "availability": 3
    },
    {
        "data": "2022-02-05",
        "origin": "COR",
        "destination": "BRC",
        "price": 317.28,
        "availability": 4
    },
    {
        "data": "2022-02-05",
        "origin": "EPA",
        "destination": "BRC",
        "price": 196.77,
        "availability": 2
    },
    {
        "data": "2022-01-03",
        "origin": "COR",
        "destination": "MDZ",
        "price": 214.54,
        "availability": 1
    },
    {
        "data": "2022-01-03",
        "origin": "COR",
        "destination": "BRC",
        "price": 406.97,
        "availability": 8
    },
    {
        "data": "2022-01-03",
        "origin": "EPA",
        "destination": "BRC",
        "price": 222.19,
        "availability": 1
    },
    {
        "data": "2022-02-06",
        "origin": "COR",
        "destination": "MDZ",
        "price": 228.89,
        "availability": 1
    },
    {
        "data": "2022-02-06",
        "origin": "COR",
        "destination": "BRC",
        "price": 371.04,
        "availability": 1
    },
    {
        "data": "2022-02-06",
        "origin": "EPA",
        "destination": "BRC",
        "price": 326.19,
        "availability": 3
    },
    {
        "data": "2022-01-08",
        "origin": "COR",
        "destination": "MDZ",
        "price": 208.84,
        "availability": 8
    },
    {
        "data": "2022-01-08",
        "origin": "COR",
        "destination": "BRC",
        "price": 438.24,
        "availability": 5
    },
    {
        "data": "2022-01-08",
        "origin": "EPA",
        "destination": "BRC",
        "price": 235.64,
        "availability": 9
    },
    {
        "data": "2022-02-04",
        "origin": "COR",
        "destination": "MDZ",
        "price": 187.39,
        "availability": 1
    },
    {
        "data": "2022-02-04",
        "origin": "COR",
        "destination": "BRC",
        "price": 405.5,
        "availability": 6
    },
    {
        "data": "2022-02-04",
        "origin": "EPA",
        "destination": "BRC",
        "price": 178.76,
        "availability": 6
    },
    {
        "data": "2022-01-13",
        "origin": "COR",
        "destination": "MDZ",
        "price": 405.24,
        "availability": 4
    },
    {
        "data": "2022-01-13",
        "origin": "COR",
        "destination": "BRC",
        "price": 189.58,
        "availability": 6
    },
    {
        "data": "2022-01-13",
        "origin": "EPA",
        "destination": "BRC",
        "price": 342.61,
        "availability": 2
    },
    {
        "data": "2022-01-27",
        "origin": "COR",
        "destination": "MDZ",
        "price": 249.48,
        "availability": 4
    },
    {
        "data": "2022-01-27",
        "origin": "COR",
        "destination": "BRC",
        "price": 271.61,
        "availability": 4
    },
    {
        "data": "2022-01-27",
        "origin": "EPA",
        "destination": "BRC",
        "price": 186.57,
        "availability": 7
    },
    {
        "data": "2022-01-10",
        "origin": "COR",
        "destination": "MDZ",
        "price": 315.35,
        "availability": 1
    },
    {
        "data": "2022-01-10",
        "origin": "COR",
        "destination": "BRC",
        "price": 223.61,
        "availability": 1
    },
    {
        "data": "2022-01-10",
        "origin": "EPA",
        "destination": "BRC",
        "price": 245.71,
        "availability": 9
    },
    {
        "data": "2022-02-14",
        "origin": "COR",
        "destination": "MDZ",
        "price": 344,
        "availability": 6
    },
    {
        "data": "2022-02-14",
        "origin": "COR",
        "destination": "BRC",
        "price": 243.27,
        "availability": 1
    },
    {
        "data": "2022-02-14",
        "origin": "EPA",
        "destination": "BRC",
        "price": 407.15,
        "availability": 9
    },
    {
        "data": "2022-01-12",
        "origin": "COR",
        "destination": "MDZ",
        "price": 354.52,
        "availability": 8
    },
    {
        "data": "2022-01-12",
        "origin": "COR",
        "destination": "BRC",
        "price": 302.1,
        "availability": 8
    },
    {
        "data": "2022-01-12",
        "origin": "EPA",
        "destination": "BRC",
        "price": 448.63,
        "availability": 9
    },
    {
        "data": "2022-02-17",
        "origin": "COR",
        "destination": "MDZ",
        "price": 198.14,
        "availability": 2
    },
    {
        "data": "2022-02-17",
        "origin": "COR",
        "destination": "BRC",
        "price": 166.58,
        "availability": 1
    },
    {
        "data": "2022-02-17",
        "origin": "EPA",
        "destination": "BRC",
        "price": 189.12,
        "availability": 7
    },
    {
        "data": "2022-01-11",
        "origin": "COR",
        "destination": "MDZ",
        "price": 197.81,
        "availability": 4
    },
    {
        "data": "2022-01-11",
        "origin": "COR",
        "destination": "BRC",
        "price": 243.96,
        "availability": 9
    },
    {
        "data": "2022-01-11",
        "origin": "EPA",
        "destination": "BRC",
        "price": 497.19,
        "availability": 7
    },
    {
        "data": "2022-02-15",
        "origin": "COR",
        "destination": "MDZ",
        "price": 283.06,
        "availability": 6
    },
    {
        "data": "2022-02-15",
        "origin": "COR",
        "destination": "BRC",
        "price": 347.13,
        "availability": 8
    },
    {
        "data": "2022-02-15",
        "origin": "EPA",
        "destination": "BRC",
        "price": 215.21,
        "availability": 4
    },
    {
        "data": "2022-01-21",
        "origin": "COR",
        "destination": "MDZ",
        "price": 166.85,
        "availability": 6
    },
    {
        "data": "2022-01-21",
        "origin": "COR",
        "destination": "BRC",
        "price": 385.19,
        "availability": 6
    },
    {
        "data": "2022-01-21",
        "origin": "EPA",
        "destination": "BRC",
        "price": 410.22,
        "availability": 4
    },
    {
        "data": "2022-02-07",
        "origin": "COR",
        "destination": "MDZ",
        "price": 459.06,
        "availability": 5
    },
    {
        "data": "2022-02-07",
        "origin": "COR",
        "destination": "BRC",
        "price": 323.03,
        "availability": 1
    },
    {
        "data": "2022-02-07",
        "origin": "EPA",
        "destination": "BRC",
        "price": 356.17,
        "availability": 9
    },
    {
        "data": "2022-01-18",
        "origin": "COR",
        "destination": "MDZ",
        "price": 203.02,
        "availability": 7
    },
    {
        "data": "2022-01-18",
        "origin": "COR",
        "destination": "BRC",
        "price": 410.14,
        "availability": 6
    },
    {
        "data": "2022-01-18",
        "origin": "EPA",
        "destination": "BRC",
        "price": 482.93,
        "availability": 1
    },
    {
        "data": "2022-02-27",
        "origin": "COR",
        "destination": "MDZ",
        "price": 170.04,
        "availability": 7
    },
    {
        "data": "2022-02-27",
        "origin": "COR",
        "destination": "BRC",
        "price": 455.96,
        "availability": 2
    },
    {
        "data": "2022-02-27",
        "origin": "EPA",
        "destination": "BRC",
        "price": 232.12,
        "availability": 9
    },
    {
        "data": "2022-01-20",
        "origin": "COR",
        "destination": "MDZ",
        "price": 265.86,
        "availability": 2
    },
    {
        "data": "2022-01-20",
        "origin": "COR",
        "destination": "BRC",
        "price": 313.8,
        "availability": 3
    },
    {
        "data": "2022-01-20",
        "origin": "EPA",
        "destination": "BRC",
        "price": 301.92,
        "availability": 5
    },
    {
        "data": "2022-02-25",
        "origin": "COR",
        "destination": "MDZ",
        "price": 192.67,
        "availability": 8
    },
    {
        "data": "2022-02-25",
        "origin": "COR",
        "destination": "BRC",
        "price": 153.07,
        "availability": 2
    },
    {
        "data": "2022-02-25",
        "origin": "EPA",
        "destination": "BRC",
        "price": 297.21,
        "availability": 5
    },
    {
        "data": "2022-01-19",
        "origin": "COR",
        "destination": "MDZ",
        "price": 421.13,
        "availability": 5
    },
    {
        "data": "2022-01-19",
        "origin": "COR",
        "destination": "BRC",
        "price": 362.95,
        "availability": 6
    },
    {
        "data": "2022-01-19",
        "origin": "EPA",
        "destination": "BRC",
        "price": 205.2,
        "availability": 1
    },
    {
        "data": "2022-02-26",
        "origin": "COR",
        "destination": "MDZ",
        "price": 359.77,
        "availability": 4
    },
    {
        "data": "2022-02-26",
        "origin": "COR",
        "destination": "BRC",
        "price": 319.85,
        "availability": 4
    },
    {
        "data": "2022-02-26",
        "origin": "EPA",
        "destination": "BRC",
        "price": 253.2,
        "availability": 7
    },
    {
        "data": "2022-01-29",
        "origin": "COR",
        "destination": "MDZ",
        "price": 251.23,
        "availability": 2
    },
    {
        "data": "2022-01-29",
        "origin": "COR",
        "destination": "BRC",
        "price": 388.89,
        "availability": 5
    },
    {
        "data": "2022-01-29",
        "origin": "EPA",
        "destination": "BRC",
        "price": 173.39,
        "availability": 9
    },
    {
        "data": "2022-02-16",
        "origin": "COR",
        "destination": "MDZ",
        "price": 233.34,
        "availability": 8
    },
    {
        "data": "2022-02-16",
        "origin": "COR",
        "destination": "BRC",
        "price": 493.09,
        "availability": 7
    },
    {
        "data": "2022-02-16",
        "origin": "EPA",
        "destination": "BRC",
        "price": 497.89,
        "availability": 7
    },
    {
        "data": "2022-01-23",
        "origin": "COR",
        "destination": "MDZ",
        "price": 459.21,
        "availability": 7
    },
    {
        "data": "2022-01-23",
        "origin": "COR",
        "destination": "BRC",
        "price": 433.14,
        "availability": 3
    },
    {
        "data": "2022-01-23",
        "origin": "EPA",
        "destination": "BRC",
        "price": 413.85,
        "availability": 2
    },
    {
        "data": "2022-03-04",
        "origin": "COR",
        "destination": "MDZ",
        "price": 472.55,
        "availability": 3
    },
    {
        "data": "2022-03-04",
        "origin": "COR",
        "destination": "BRC",
        "price": 336.39,
        "availability": 6
    },
    {
        "data": "2022-03-04",
        "origin": "EPA",
        "destination": "BRC",
        "price": 421.14,
        "availability": 2
    },
    {
        "data": "2022-01-28",
        "origin": "COR",
        "destination": "MDZ",
        "price": 367.39,
        "availability": 4
    },
    {
        "data": "2022-01-28",
        "origin": "COR",
        "destination": "BRC",
        "price": 338.77,
        "availability": 4
    },
    {
        "data": "2022-01-28",
        "origin": "EPA",
        "destination": "BRC",
        "price": 303.42,
        "availability": 6
    },
    {
        "data": "2022-03-06",
        "origin": "COR",
        "destination": "MDZ",
        "price": 214.64,
        "availability": 5
    },
    {
        "data": "2022-03-06",
        "origin": "COR",
        "destination": "BRC",
        "price": 393.8,
        "availability": 1
    },
    {
        "data": "2022-03-06",
        "origin": "EPA",
        "destination": "BRC",
        "price": 249.72,
        "availability": 5
    },
    {
        "data": "2022-01-22",
        "origin": "COR",
        "destination": "MDZ",
        "price": 327.41,
        "availability": 5
    },
    {
        "data": "2022-01-22",
        "origin": "COR",
        "destination": "BRC",
        "price": 284.17,
        "availability": 4
    },
    {
        "data": "2022-01-22",
        "origin": "EPA",
        "destination": "BRC",
        "price": 466.16,
        "availability": 2
    },
    {
        "data": "2022-03-05",
        "origin": "COR",
        "destination": "MDZ",
        "price": 212.1,
        "availability": 8
    },
    {
        "data": "2022-03-05",
        "origin": "COR",
        "destination": "BRC",
        "price": 414.85,
        "availability": 2
    },
    {
        "data": "2022-03-05",
        "origin": "EPA",
        "destination": "BRC",
        "price": 265.17,
        "availability": 9
    },
    {
        "data": "2022-01-30",
        "origin": "COR",
        "destination": "MDZ",
        "price": 398.82,
        "availability": 2
    },
    {
        "data": "2022-01-30",
        "origin": "COR",
        "destination": "BRC",
        "price": 191.19,
        "availability": 8
    },
    {
        "data": "2022-01-30",
        "origin": "EPA",
        "destination": "BRC",
        "price": 392.59,
        "availability": 7
    },
    {
        "data": "2022-02-24",
        "origin": "COR",
        "destination": "MDZ",
        "price": 258.91,
        "availability": 7
    },
    {
        "data": "2022-02-24",
        "origin": "COR",
        "destination": "BRC",
        "price": 278.24,
        "availability": 3
    },
    {
        "data": "2022-02-24",
        "origin": "EPA",
        "destination": "BRC",
        "price": 381.87,
        "availability": 9
    },
    {
        "data": "2022-02-03",
        "origin": "COR",
        "destination": "MDZ",
        "price": 316.08,
        "availability": 3
    },
    {
        "data": "2022-02-03",
        "origin": "COR",
        "destination": "BRC",
        "price": 398.83,
        "availability": 6
    },
    {
        "data": "2022-02-03",
        "origin": "EPA",
        "destination": "BRC",
        "price": 497.76,
        "availability": 9
    },
    {
        "data": "2022-03-15",
        "origin": "COR",
        "destination": "MDZ",
        "price": 252.78,
        "availability": 7
    },
    {
        "data": "2022-03-15",
        "origin": "COR",
        "destination": "BRC",
        "price": 207.64,
        "availability": 7
    },
    {
        "data": "2022-03-15",
        "origin": "EPA",
        "destination": "BRC",
        "price": 295.44,
        "availability": 2
    },
    {
        "data": "2022-01-31",
        "origin": "COR",
        "destination": "MDZ",
        "price": 365.32,
        "availability": 7
    },
    {
        "data": "2022-01-31",
        "origin": "COR",
        "destination": "BRC",
        "price": 154.61,
        "availability": 9
    },
    {
        "data": "2022-01-31",
        "origin": "EPA",
        "destination": "BRC",
        "price": 175.64,
        "availability": 5
    },
    {
        "data": "2022-03-17",
        "origin": "COR",
        "destination": "MDZ",
        "price": 384.51,
        "availability": 3
    },
    {
        "data": "2022-03-17",
        "origin": "COR",
        "destination": "BRC",
        "price": 489.08,
        "availability": 4
    },
    {
        "data": "2022-03-17",
        "origin": "EPA",
        "destination": "BRC",
        "price": 312.46,
        "availability": 4
    },
    {
        "data": "2022-02-02",
        "origin": "COR",
        "destination": "MDZ",
        "price": 429.55,
        "availability": 3
    },
    {
        "data": "2022-02-02",
        "origin": "COR",
        "destination": "BRC",
        "price": 443.26,
        "availability": 7
    },
    {
        "data": "2022-02-02",
        "origin": "EPA",
        "destination": "BRC",
        "price": 295.19,
        "availability": 1
    },
    {
        "data": "2022-03-09",
        "origin": "COR",
        "destination": "MDZ",
        "price": 203.06,
        "availability": 4
    },
    {
        "data": "2022-03-09",
        "origin": "COR",
        "destination": "BRC",
        "price": 472.33,
        "availability": 3
    },
    {
        "data": "2022-03-09",
        "origin": "EPA",
        "destination": "BRC",
        "price": 279.01,
        "availability": 8
    },
    {
        "data": "2022-02-08",
        "origin": "COR",
        "destination": "MDZ",
        "price": 428.91,
        "availability": 1
    },
    {
        "data": "2022-02-08",
        "origin": "COR",
        "destination": "BRC",
        "price": 256.52,
        "availability": 8
    },
    {
        "data": "2022-02-08",
        "origin": "EPA",
        "destination": "BRC",
        "price": 186.25,
        "availability": 4
    },
    {
        "data": "2022-03-07",
        "origin": "COR",
        "destination": "MDZ",
        "price": 277.67,
        "availability": 6
    },
    {
        "data": "2022-03-07",
        "origin": "COR",
        "destination": "BRC",
        "price": 170,
        "availability": 9
    },
    {
        "data": "2022-03-07",
        "origin": "EPA",
        "destination": "BRC",
        "price": 323.82,
        "availability": 7
    },
    {
        "data": "2022-02-12",
        "origin": "COR",
        "destination": "MDZ",
        "price": 333.52,
        "availability": 7
    },
    {
        "data": "2022-02-12",
        "origin": "COR",
        "destination": "BRC",
        "price": 161.01,
        "availability": 7
    },
    {
        "data": "2022-02-12",
        "origin": "EPA",
        "destination": "BRC",
        "price": 180.77,
        "availability": 4
    },
    {
        "data": "2022-03-27",
        "origin": "COR",
        "destination": "MDZ",
        "price": 225.71,
        "availability": 6
    },
    {
        "data": "2022-03-27",
        "origin": "COR",
        "destination": "BRC",
        "price": 448.72,
        "availability": 6
    },
    {
        "data": "2022-03-27",
        "origin": "EPA",
        "destination": "BRC",
        "price": 199.69,
        "availability": 4
    },
    {
        "data": "2022-02-01",
        "origin": "COR",
        "destination": "MDZ",
        "price": 386.05,
        "availability": 6
    },
    {
        "data": "2022-02-01",
        "origin": "COR",
        "destination": "BRC",
        "price": 398.14,
        "availability": 8
    },
    {
        "data": "2022-02-01",
        "origin": "EPA",
        "destination": "BRC",
        "price": 290.44,
        "availability": 2
    },
    {
        "data": "2022-03-24",
        "origin": "COR",
        "destination": "MDZ",
        "price": 464.97,
        "availability": 9
    },
    {
        "data": "2022-03-24",
        "origin": "COR",
        "destination": "BRC",
        "price": 417.6,
        "availability": 8
    },
    {
        "data": "2022-03-24",
        "origin": "EPA",
        "destination": "BRC",
        "price": 220.08,
        "availability": 6
    },
    {
        "data": "2022-02-13",
        "origin": "COR",
        "destination": "MDZ",
        "price": 476.97,
        "availability": 5
    },
    {
        "data": "2022-02-13",
        "origin": "COR",
        "destination": "BRC",
        "price": 488.07,
        "availability": 2
    },
    {
        "data": "2022-02-13",
        "origin": "EPA",
        "destination": "BRC",
        "price": 405.53,
        "availability": 6
    },
    {
        "data": "2022-03-14",
        "origin": "COR",
        "destination": "MDZ",
        "price": 419.57,
        "availability": 7
    },
    {
        "data": "2022-03-14",
        "origin": "COR",
        "destination": "BRC",
        "price": 188.6,
        "availability": 2
    },
    {
        "data": "2022-03-14",
        "origin": "EPA",
        "destination": "BRC",
        "price": 400.64,
        "availability": 4
    },
    {
        "data": "2022-02-11",
        "origin": "COR",
        "destination": "MDZ",
        "price": 258.18,
        "availability": 7
    },
    {
        "data": "2022-02-11",
        "origin": "COR",
        "destination": "BRC",
        "price": 292.41,
        "availability": 5
    },
    {
        "data": "2022-02-11",
        "origin": "EPA",
        "destination": "BRC",
        "price": 481.54,
        "availability": 1
    },
    {
        "data": "2022-03-16",
        "origin": "COR",
        "destination": "MDZ",
        "price": 441.11,
        "availability": 8
    },
    {
        "data": "2022-03-16",
        "origin": "COR",
        "destination": "BRC",
        "price": 456.8,
        "availability": 1
    },
    {
        "data": "2022-03-16",
        "origin": "EPA",
        "destination": "BRC",
        "price": 200.91,
        "availability": 3
    },
    {
        "data": "2022-02-20",
        "origin": "COR",
        "destination": "MDZ",
        "price": 463.51,
        "availability": 7
    },
    {
        "data": "2022-02-20",
        "origin": "COR",
        "destination": "BRC",
        "price": 185.67,
        "availability": 5
    },
    {
        "data": "2022-02-20",
        "origin": "EPA",
        "destination": "BRC",
        "price": 294.43,
        "availability": 1
    },
    {
        "data": "2022-04-08",
        "origin": "COR",
        "destination": "MDZ",
        "price": 306.45,
        "availability": 9
    },
    {
        "data": "2022-04-08",
        "origin": "COR",
        "destination": "BRC",
        "price": 386.03,
        "availability": 7
    },
    {
        "data": "2022-04-08",
        "origin": "EPA",
        "destination": "BRC",
        "price": 443.14,
        "availability": 8
    },
    {
        "data": "2022-02-09",
        "origin": "COR",
        "destination": "MDZ",
        "price": 462.55,
        "availability": 3
    },
    {
        "data": "2022-02-09",
        "origin": "COR",
        "destination": "BRC",
        "price": 160.54,
        "availability": 8
    },
    {
        "data": "2022-02-09",
        "origin": "EPA",
        "destination": "BRC",
        "price": 153.59,
        "availability": 5
    },
    {
        "data": "2022-04-02",
        "origin": "COR",
        "destination": "MDZ",
        "price": 332.83,
        "availability": 7
    },
    {
        "data": "2022-04-02",
        "origin": "COR",
        "destination": "BRC",
        "price": 496.6,
        "availability": 4
    },
    {
        "data": "2022-04-02",
        "origin": "EPA",
        "destination": "BRC",
        "price": 321.61,
        "availability": 4
    },
    {
        "data": "2022-02-21",
        "origin": "COR",
        "destination": "MDZ",
        "price": 485.02,
        "availability": 3
    },
    {
        "data": "2022-02-21",
        "origin": "COR",
        "destination": "BRC",
        "price": 235.83,
        "availability": 1
    },
    {
        "data": "2022-02-21",
        "origin": "EPA",
        "destination": "BRC",
        "price": 246.31,
        "availability": 8
    },
    {
        "data": "2022-03-26",
        "origin": "COR",
        "destination": "MDZ",
        "price": 395.41,
        "availability": 5
    },
    {
        "data": "2022-03-26",
        "origin": "COR",
        "destination": "BRC",
        "price": 473.48,
        "availability": 6
    },
    {
        "data": "2022-03-26",
        "origin": "EPA",
        "destination": "BRC",
        "price": 456.39,
        "availability": 4
    },
    {
        "data": "2022-02-19",
        "origin": "COR",
        "destination": "MDZ",
        "price": 353.88,
        "availability": 4
    },
    {
        "data": "2022-02-19",
        "origin": "COR",
        "destination": "BRC",
        "price": 178.15,
        "availability": 4
    },
    {
        "data": "2022-02-19",
        "origin": "EPA",
        "destination": "BRC",
        "price": 343.94,
        "availability": 1
    },
    {
        "data": "2022-03-25",
        "origin": "COR",
        "destination": "MDZ",
        "price": 260.97,
        "availability": 7
    },
    {
        "data": "2022-03-25",
        "origin": "COR",
        "destination": "BRC",
        "price": 212.47,
        "availability": 2
    },
    {
        "data": "2022-03-25",
        "origin": "EPA",
        "destination": "BRC",
        "price": 312.64,
        "availability": 5
    },
    {
        "data": "2022-02-28",
        "origin": "COR",
        "destination": "MDZ",
        "price": 359.05,
        "availability": 5
    },
    {
        "data": "2022-02-28",
        "origin": "COR",
        "destination": "BRC",
        "price": 472.64,
        "availability": 1
    },
    {
        "data": "2022-02-28",
        "origin": "EPA",
        "destination": "BRC",
        "price": 281.88,
        "availability": 1
    },
    {
        "data": "2022-04-11",
        "origin": "COR",
        "destination": "MDZ",
        "price": 291.98,
        "availability": 9
    },
    {
        "data": "2022-04-11",
        "origin": "COR",
        "destination": "BRC",
        "price": 403.78,
        "availability": 5
    },
    {
        "data": "2022-04-11",
        "origin": "EPA",
        "destination": "BRC",
        "price": 272.32,
        "availability": 4
    },
    {
        "data": "2022-02-10",
        "origin": "COR",
        "destination": "MDZ",
        "price": 261.65,
        "availability": 6
    },
    {
        "data": "2022-02-10",
        "origin": "COR",
        "destination": "BRC",
        "price": 367.47,
        "availability": 4
    },
    {
        "data": "2022-02-10",
        "origin": "EPA",
        "destination": "BRC",
        "price": 329.68,
        "availability": 2
    },
    {
        "data": "2022-04-13",
        "origin": "COR",
        "destination": "MDZ",
        "price": 176.34,
        "availability": 7
    },
    {
        "data": "2022-04-13",
        "origin": "COR",
        "destination": "BRC",
        "price": 410.21,
        "availability": 3
    },
    {
        "data": "2022-04-13",
        "origin": "EPA",
        "destination": "BRC",
        "price": 194.69,
        "availability": 5
    },
    {
        "data": "2022-03-02",
        "origin": "COR",
        "destination": "MDZ",
        "price": 194.01,
        "availability": 6
    },
    {
        "data": "2022-03-02",
        "origin": "COR",
        "destination": "BRC",
        "price": 417.91,
        "availability": 5
    },
    {
        "data": "2022-03-02",
        "origin": "EPA",
        "destination": "BRC",
        "price": 187.73,
        "availability": 6
    },
    {
        "data": "2022-04-01",
        "origin": "COR",
        "destination": "MDZ",
        "price": 485.61,
        "availability": 5
    },
    {
        "data": "2022-04-01",
        "origin": "COR",
        "destination": "BRC",
        "price": 491.54,
        "availability": 4
    },
    {
        "data": "2022-04-01",
        "origin": "EPA",
        "destination": "BRC",
        "price": 183.86,
        "availability": 7
    },
    {
        "data": "2022-02-22",
        "origin": "COR",
        "destination": "MDZ",
        "price": 198.72,
        "availability": 6
    },
    {
        "data": "2022-02-22",
        "origin": "COR",
        "destination": "BRC",
        "price": 202.14,
        "availability": 8
    },
    {
        "data": "2022-02-22",
        "origin": "EPA",
        "destination": "BRC",
        "price": 444.95,
        "availability": 9
    },
    {
        "data": "2022-03-29",
        "origin": "COR",
        "destination": "MDZ",
        "price": 417.65,
        "availability": 9
    },
    {
        "data": "2022-03-29",
        "origin": "COR",
        "destination": "BRC",
        "price": 401.76,
        "availability": 8
    },
    {
        "data": "2022-03-29",
        "origin": "EPA",
        "destination": "BRC",
        "price": 418.31,
        "availability": 9
    },
    {
        "data": "2022-03-03",
        "origin": "COR",
        "destination": "MDZ",
        "price": 214.91,
        "availability": 6
    },
    {
        "data": "2022-03-03",
        "origin": "COR",
        "destination": "BRC",
        "price": 341.21,
        "availability": 5
    },
    {
        "data": "2022-03-03",
        "origin": "EPA",
        "destination": "BRC",
        "price": 340.5,
        "availability": 2
    },
    {
        "data": "2022-04-19",
        "origin": "COR",
        "destination": "MDZ",
        "price": 153.14,
        "availability": 6
    },
    {
        "data": "2022-04-19",
        "origin": "COR",
        "destination": "BRC",
        "price": 446.68,
        "availability": 1
    },
    {
        "data": "2022-04-19",
        "origin": "EPA",
        "destination": "BRC",
        "price": 395.77,
        "availability": 8
    },
    {
        "data": "2022-02-18",
        "origin": "COR",
        "destination": "MDZ",
        "price": 273.82,
        "availability": 5
    },
    {
        "data": "2022-02-18",
        "origin": "COR",
        "destination": "BRC",
        "price": 400.31,
        "availability": 4
    },
    {
        "data": "2022-02-18",
        "origin": "EPA",
        "destination": "BRC",
        "price": 235.39,
        "availability": 8
    },
    {
        "data": "2022-04-20",
        "origin": "COR",
        "destination": "MDZ",
        "price": 420.4,
        "availability": 7
    },
    {
        "data": "2022-04-20",
        "origin": "COR",
        "destination": "BRC",
        "price": 289.62,
        "availability": 3
    },
    {
        "data": "2022-04-20",
        "origin": "EPA",
        "destination": "BRC",
        "price": 329.32,
        "availability": 5
    },
    {
        "data": "2022-03-13",
        "origin": "COR",
        "destination": "MDZ",
        "price": 420.63,
        "availability": 8
    },
    {
        "data": "2022-03-13",
        "origin": "COR",
        "destination": "BRC",
        "price": 441.43,
        "availability": 6
    },
    {
        "data": "2022-03-13",
        "origin": "EPA",
        "destination": "BRC",
        "price": 480.43,
        "availability": 5
    },
    {
        "data": "2022-04-09",
        "origin": "COR",
        "destination": "MDZ",
        "price": 267.54,
        "availability": 1
    },
    {
        "data": "2022-04-09",
        "origin": "COR",
        "destination": "BRC",
        "price": 230.41,
        "availability": 9
    },
    {
        "data": "2022-04-09",
        "origin": "EPA",
        "destination": "BRC",
        "price": 186.52,
        "availability": 1
    },
    {
        "data": "2022-03-01",
        "origin": "COR",
        "destination": "MDZ",
        "price": 224.35,
        "availability": 2
    },
    {
        "data": "2022-03-01",
        "origin": "COR",
        "destination": "BRC",
        "price": 362.91,
        "availability": 6
    },
    {
        "data": "2022-03-01",
        "origin": "EPA",
        "destination": "BRC",
        "price": 268.48,
        "availability": 2
    },
    {
        "data": "2022-04-03",
        "origin": "COR",
        "destination": "MDZ",
        "price": 202.32,
        "availability": 2
    },
    {
        "data": "2022-04-03",
        "origin": "COR",
        "destination": "BRC",
        "price": 323.67,
        "availability": 3
    },
    {
        "data": "2022-04-03",
        "origin": "EPA",
        "destination": "BRC",
        "price": 157.12,
        "availability": 2
    },
    {
        "data": "2022-03-12",
        "origin": "COR",
        "destination": "MDZ",
        "price": 457.43,
        "availability": 3
    },
    {
        "data": "2022-03-12",
        "origin": "COR",
        "destination": "BRC",
        "price": 321.98,
        "availability": 2
    },
    {
        "data": "2022-03-12",
        "origin": "EPA",
        "destination": "BRC",
        "price": 257.35,
        "availability": 1
    },
    {
        "data": "2022-04-23",
        "origin": "COR",
        "destination": "MDZ",
        "price": 397.04,
        "availability": 9
    },
    {
        "data": "2022-04-23",
        "origin": "COR",
        "destination": "BRC",
        "price": 472.74,
        "availability": 3
    },
    {
        "data": "2022-04-23",
        "origin": "EPA",
        "destination": "BRC",
        "price": 498.92,
        "availability": 7
    },
    {
        "data": "2022-02-23",
        "origin": "COR",
        "destination": "MDZ",
        "price": 494.89,
        "availability": 7
    },
    {
        "data": "2022-02-23",
        "origin": "COR",
        "destination": "BRC",
        "price": 344.35,
        "availability": 8
    },
    {
        "data": "2022-02-23",
        "origin": "EPA",
        "destination": "BRC",
        "price": 264.91,
        "availability": 1
    },
    {
        "data": "2022-04-28",
        "origin": "COR",
        "destination": "MDZ",
        "price": 189.4,
        "availability": 6
    },
    {
        "data": "2022-04-28",
        "origin": "COR",
        "destination": "BRC",
        "price": 310.61,
        "availability": 6
    },
    {
        "data": "2022-04-28",
        "origin": "EPA",
        "destination": "BRC",
        "price": 384.53,
        "availability": 9
    },
    {
        "data": "2022-03-20",
        "origin": "COR",
        "destination": "MDZ",
        "price": 415.72,
        "availability": 1
    },
    {
        "data": "2022-03-20",
        "origin": "COR",
        "destination": "BRC",
        "price": 293.37,
        "availability": 9
    },
    {
        "data": "2022-03-20",
        "origin": "EPA",
        "destination": "BRC",
        "price": 270.01,
        "availability": 2
    },
    {
        "data": "2022-04-10",
        "origin": "COR",
        "destination": "MDZ",
        "price": 386.43,
        "availability": 9
    },
    {
        "data": "2022-04-10",
        "origin": "COR",
        "destination": "BRC",
        "price": 303.53,
        "availability": 4
    },
    {
        "data": "2022-04-10",
        "origin": "EPA",
        "destination": "BRC",
        "price": 270.15,
        "availability": 4
    },
    {
        "data": "2022-03-10",
        "origin": "COR",
        "destination": "MDZ",
        "price": 205.07,
        "availability": 1
    },
    {
        "data": "2022-03-10",
        "origin": "COR",
        "destination": "BRC",
        "price": 247.51,
        "availability": 5
    },
    {
        "data": "2022-03-10",
        "origin": "EPA",
        "destination": "BRC",
        "price": 342.33,
        "availability": 2
    },
    {
        "data": "2022-04-12",
        "origin": "COR",
        "destination": "MDZ",
        "price": 478.96,
        "availability": 5
    },
    {
        "data": "2022-04-12",
        "origin": "COR",
        "destination": "BRC",
        "price": 317.51,
        "availability": 6
    },
    {
        "data": "2022-04-12",
        "origin": "EPA",
        "destination": "BRC",
        "price": 257.95,
        "availability": 2
    },
    {
        "data": "2022-03-21",
        "origin": "COR",
        "destination": "MDZ",
        "price": 195.12,
        "availability": 8
    },
    {
        "data": "2022-03-21",
        "origin": "COR",
        "destination": "BRC",
        "price": 183.89,
        "availability": 6
    },
    {
        "data": "2022-03-21",
        "origin": "EPA",
        "destination": "BRC",
        "price": 396.05,
        "availability": 7
    },
    {
        "data": "2021-11-17",
        "origin": "MDZ",
        "destination": "COR",
        "price": 312.27,
        "availability": 6
    },
    {
        "data": "2021-11-17",
        "origin": "BRC",
        "destination": "COR",
        "price": 399.95,
        "availability": 1
    },
    {
        "data": "2021-11-17",
        "origin": "BRC",
        "destination": "EPA",
        "price": 451.01,
        "availability": 8
    },
    {
        "data": "2022-03-08",
        "origin": "COR",
        "destination": "MDZ",
        "price": 415.87,
        "availability": 7
    },
    {
        "data": "2022-03-08",
        "origin": "COR",
        "destination": "BRC",
        "price": 181.36,
        "availability": 1
    },
    {
        "data": "2022-03-08",
        "origin": "EPA",
        "destination": "BRC",
        "price": 154.27,
        "availability": 7
    },
    {
        "data": "2022-05-03",
        "origin": "COR",
        "destination": "MDZ",
        "price": 482.57,
        "availability": 8
    },
    {
        "data": "2022-05-03",
        "origin": "COR",
        "destination": "BRC",
        "price": 468.22,
        "availability": 4
    },
    {
        "data": "2022-05-03",
        "origin": "EPA",
        "destination": "BRC",
        "price": 367.21,
        "availability": 5
    },
    {
        "data": "2022-03-28",
        "origin": "COR",
        "destination": "MDZ",
        "price": 229.91,
        "availability": 8
    },
    {
        "data": "2022-03-28",
        "origin": "COR",
        "destination": "BRC",
        "price": 292.47,
        "availability": 1
    },
    {
        "data": "2022-03-28",
        "origin": "EPA",
        "destination": "BRC",
        "price": 490.49,
        "availability": 6
    },
    {
        "data": "2022-04-18",
        "origin": "COR",
        "destination": "MDZ",
        "price": 440.18,
        "availability": 3
    },
    {
        "data": "2022-04-18",
        "origin": "COR",
        "destination": "BRC",
        "price": 153.02,
        "availability": 1
    },
    {
        "data": "2022-04-18",
        "origin": "EPA",
        "destination": "BRC",
        "price": 494.6,
        "availability": 8
    },
    {
        "data": "2022-03-18",
        "origin": "COR",
        "destination": "MDZ",
        "price": 158.54,
        "availability": 2
    },
    {
        "data": "2022-03-18",
        "origin": "COR",
        "destination": "BRC",
        "price": 480.94,
        "availability": 2
    },
    {
        "data": "2022-03-18",
        "origin": "EPA",
        "destination": "BRC",
        "price": 248.04,
        "availability": 1
    },
    {
        "data": "2022-04-21",
        "origin": "COR",
        "destination": "MDZ",
        "price": 431.95,
        "availability": 8
    },
    {
        "data": "2022-04-21",
        "origin": "COR",
        "destination": "BRC",
        "price": 380.54,
        "availability": 2
    },
    {
        "data": "2022-04-21",
        "origin": "EPA",
        "destination": "BRC",
        "price": 445.85,
        "availability": 8
    },
    {
        "data": "2022-03-30",
        "origin": "COR",
        "destination": "MDZ",
        "price": 180.27,
        "availability": 8
    },
    {
        "data": "2022-03-30",
        "origin": "COR",
        "destination": "BRC",
        "price": 364.08,
        "availability": 5
    },
    {
        "data": "2022-03-30",
        "origin": "EPA",
        "destination": "BRC",
        "price": 369.96,
        "availability": 6
    },
    {
        "data": "2021-11-24",
        "origin": "MDZ",
        "destination": "COR",
        "price": 374.5,
        "availability": 3
    },
    {
        "data": "2021-11-24",
        "origin": "BRC",
        "destination": "COR",
        "price": 157.36,
        "availability": 4
    },
    {
        "data": "2021-11-24",
        "origin": "BRC",
        "destination": "EPA",
        "price": 450.28,
        "availability": 7
    },
    {
        "data": "2022-03-11",
        "origin": "COR",
        "destination": "MDZ",
        "price": 275.36,
        "availability": 7
    },
    {
        "data": "2022-03-11",
        "origin": "COR",
        "destination": "BRC",
        "price": 383.14,
        "availability": 9
    },
    {
        "data": "2022-03-11",
        "origin": "EPA",
        "destination": "BRC",
        "price": 156.79,
        "availability": 2
    },
    {
        "data": "2021-11-15",
        "origin": "MDZ",
        "destination": "COR",
        "price": 275.75,
        "availability": 4
    },
    {
        "data": "2021-11-15",
        "origin": "BRC",
        "destination": "COR",
        "price": 384.91,
        "availability": 5
    },
    {
        "data": "2021-11-15",
        "origin": "BRC",
        "destination": "EPA",
        "price": 417.6,
        "availability": 7
    },
    {
        "data": "2022-03-31",
        "origin": "COR",
        "destination": "MDZ",
        "price": 270.74,
        "availability": 7
    },
    {
        "data": "2022-03-31",
        "origin": "COR",
        "destination": "BRC",
        "price": 171.12,
        "availability": 9
    },
    {
        "data": "2022-03-31",
        "origin": "EPA",
        "destination": "BRC",
        "price": 336.45,
        "availability": 7
    },
    {
        "data": "2022-04-22",
        "origin": "COR",
        "destination": "MDZ",
        "price": 486.74,
        "availability": 3
    },
    {
        "data": "2022-04-22",
        "origin": "COR",
        "destination": "BRC",
        "price": 469.35,
        "availability": 5
    },
    {
        "data": "2022-04-22",
        "origin": "EPA",
        "destination": "BRC",
        "price": 181.3,
        "availability": 7
    },
    {
        "data": "2022-03-22",
        "origin": "COR",
        "destination": "MDZ",
        "price": 402.77,
        "availability": 9
    },
    {
        "data": "2022-03-22",
        "origin": "COR",
        "destination": "BRC",
        "price": 278.3,
        "availability": 1
    },
    {
        "data": "2022-03-22",
        "origin": "EPA",
        "destination": "BRC",
        "price": 414.55,
        "availability": 9
    },
    {
        "data": "2022-04-29",
        "origin": "COR",
        "destination": "MDZ",
        "price": 166.39,
        "availability": 8
    },
    {
        "data": "2022-04-29",
        "origin": "COR",
        "destination": "BRC",
        "price": 472.76,
        "availability": 1
    },
    {
        "data": "2022-04-29",
        "origin": "EPA",
        "destination": "BRC",
        "price": 408.27,
        "availability": 6
    },
    {
        "data": "2022-04-07",
        "origin": "COR",
        "destination": "MDZ",
        "price": 326.33,
        "availability": 4
    },
    {
        "data": "2022-04-07",
        "origin": "COR",
        "destination": "BRC",
        "price": 287.66,
        "availability": 6
    },
    {
        "data": "2022-04-07",
        "origin": "EPA",
        "destination": "BRC",
        "price": 388.44,
        "availability": 8
    },
    {
        "data": "2021-12-03",
        "origin": "MDZ",
        "destination": "COR",
        "price": 286.35,
        "availability": 4
    },
    {
        "data": "2021-12-03",
        "origin": "BRC",
        "destination": "COR",
        "price": 480.76,
        "availability": 8
    },
    {
        "data": "2021-12-03",
        "origin": "BRC",
        "destination": "EPA",
        "price": 233.36,
        "availability": 3
    },
    {
        "data": "2022-03-19",
        "origin": "COR",
        "destination": "MDZ",
        "price": 315.65,
        "availability": 4
    },
    {
        "data": "2022-03-19",
        "origin": "COR",
        "destination": "BRC",
        "price": 245.35,
        "availability": 3
    },
    {
        "data": "2022-03-19",
        "origin": "EPA",
        "destination": "BRC",
        "price": 393.57,
        "availability": 6
    },
    {
        "data": "2021-11-27",
        "origin": "MDZ",
        "destination": "COR",
        "price": 150.63,
        "availability": 4
    },
    {
        "data": "2021-11-27",
        "origin": "BRC",
        "destination": "COR",
        "price": 225.46,
        "availability": 3
    },
    {
        "data": "2021-11-27",
        "origin": "BRC",
        "destination": "EPA",
        "price": 181.1,
        "availability": 8
    },
    {
        "data": "2022-04-06",
        "origin": "COR",
        "destination": "MDZ",
        "price": 307.32,
        "availability": 3
    },
    {
        "data": "2022-04-06",
        "origin": "COR",
        "destination": "BRC",
        "price": 382.93,
        "availability": 3
    },
    {
        "data": "2022-04-06",
        "origin": "EPA",
        "destination": "BRC",
        "price": 386.78,
        "availability": 2
    },
    {
        "data": "2022-05-01",
        "origin": "COR",
        "destination": "MDZ",
        "price": 188.16,
        "availability": 9
    },
    {
        "data": "2022-05-01",
        "origin": "COR",
        "destination": "BRC",
        "price": 181.38,
        "availability": 5
    },
    {
        "data": "2022-05-01",
        "origin": "EPA",
        "destination": "BRC",
        "price": 290.1,
        "availability": 4
    },
    {
        "data": "2022-04-05",
        "origin": "COR",
        "destination": "MDZ",
        "price": 376.48,
        "availability": 2
    },
    {
        "data": "2022-04-05",
        "origin": "COR",
        "destination": "BRC",
        "price": 187.04,
        "availability": 6
    },
    {
        "data": "2022-04-05",
        "origin": "EPA",
        "destination": "BRC",
        "price": 365.76,
        "availability": 1
    },
    {
        "data": "2022-04-30",
        "origin": "COR",
        "destination": "MDZ",
        "price": 224.33,
        "availability": 6
    },
    {
        "data": "2022-04-30",
        "origin": "COR",
        "destination": "BRC",
        "price": 283.34,
        "availability": 3
    },
    {
        "data": "2022-04-30",
        "origin": "EPA",
        "destination": "BRC",
        "price": 445.49,
        "availability": 6
    },
    {
        "data": "2022-04-16",
        "origin": "COR",
        "destination": "MDZ",
        "price": 274.88,
        "availability": 1
    },
    {
        "data": "2022-04-16",
        "origin": "COR",
        "destination": "BRC",
        "price": 224.83,
        "availability": 8
    },
    {
        "data": "2022-04-16",
        "origin": "EPA",
        "destination": "BRC",
        "price": 401.38,
        "availability": 7
    },
    {
        "data": "2021-12-12",
        "origin": "MDZ",
        "destination": "COR",
        "price": 406.62,
        "availability": 6
    },
    {
        "data": "2021-12-12",
        "origin": "BRC",
        "destination": "COR",
        "price": 439.64,
        "availability": 4
    },
    {
        "data": "2021-12-12",
        "origin": "BRC",
        "destination": "EPA",
        "price": 377.07,
        "availability": 6
    },
    {
        "data": "2022-03-23",
        "origin": "COR",
        "destination": "MDZ",
        "price": 158.39,
        "availability": 1
    },
    {
        "data": "2022-03-23",
        "origin": "COR",
        "destination": "BRC",
        "price": 254.04,
        "availability": 5
    },
    {
        "data": "2022-03-23",
        "origin": "EPA",
        "destination": "BRC",
        "price": 448.32,
        "availability": 6
    },
    {
        "data": "2021-12-01",
        "origin": "MDZ",
        "destination": "COR",
        "price": 171.29,
        "availability": 4
    },
    {
        "data": "2021-12-01",
        "origin": "BRC",
        "destination": "COR",
        "price": 273.9,
        "availability": 4
    },
    {
        "data": "2021-12-01",
        "origin": "BRC",
        "destination": "EPA",
        "price": 269.4,
        "availability": 1
    },
    {
        "data": "2022-04-17",
        "origin": "COR",
        "destination": "MDZ",
        "price": 268.17,
        "availability": 3
    },
    {
        "data": "2022-04-17",
        "origin": "COR",
        "destination": "BRC",
        "price": 449.22,
        "availability": 8
    },
    {
        "data": "2022-04-17",
        "origin": "EPA",
        "destination": "BRC",
        "price": 330.38,
        "availability": 2
    },
    {
        "data": "2021-11-16",
        "origin": "MDZ",
        "destination": "COR",
        "price": 353.63,
        "availability": 1
    },
    {
        "data": "2021-11-16",
        "origin": "BRC",
        "destination": "COR",
        "price": 281.29,
        "availability": 9
    },
    {
        "data": "2021-11-16",
        "origin": "BRC",
        "destination": "EPA",
        "price": 346.25,
        "availability": 1
    },
    {
        "data": "2022-04-14",
        "origin": "COR",
        "destination": "MDZ",
        "price": 436.62,
        "availability": 6
    },
    {
        "data": "2022-04-14",
        "origin": "COR",
        "destination": "BRC",
        "price": 337.18,
        "availability": 5
    },
    {
        "data": "2022-04-14",
        "origin": "EPA",
        "destination": "BRC",
        "price": 253.02,
        "availability": 1
    },
    {
        "data": "2022-05-02",
        "origin": "COR",
        "destination": "MDZ",
        "price": 199.62,
        "availability": 1
    },
    {
        "data": "2022-05-02",
        "origin": "COR",
        "destination": "BRC",
        "price": 431.69,
        "availability": 1
    },
    {
        "data": "2022-05-02",
        "origin": "EPA",
        "destination": "BRC",
        "price": 414.93,
        "availability": 8
    },
    {
        "data": "2022-04-25",
        "origin": "COR",
        "destination": "MDZ",
        "price": 412.25,
        "availability": 4
    },
    {
        "data": "2022-04-25",
        "origin": "COR",
        "destination": "BRC",
        "price": 481.6,
        "availability": 7
    },
    {
        "data": "2022-04-25",
        "origin": "EPA",
        "destination": "BRC",
        "price": 219.26,
        "availability": 6
    },
    {
        "data": "2021-12-21",
        "origin": "MDZ",
        "destination": "COR",
        "price": 481.53,
        "availability": 4
    },
    {
        "data": "2021-12-21",
        "origin": "BRC",
        "destination": "COR",
        "price": 169.55,
        "availability": 7
    },
    {
        "data": "2021-12-21",
        "origin": "BRC",
        "destination": "EPA",
        "price": 351.34,
        "availability": 8
    },
    {
        "data": "2022-04-04",
        "origin": "COR",
        "destination": "MDZ",
        "price": 220.66,
        "availability": 3
    },
    {
        "data": "2022-04-04",
        "origin": "COR",
        "destination": "BRC",
        "price": 227.22,
        "availability": 4
    },
    {
        "data": "2022-04-04",
        "origin": "EPA",
        "destination": "BRC",
        "price": 341.69,
        "availability": 3
    },
    {
        "data": "2021-12-10",
        "origin": "MDZ",
        "destination": "COR",
        "price": 381.19,
        "availability": 6
    },
    {
        "data": "2021-12-10",
        "origin": "BRC",
        "destination": "COR",
        "price": 454.86,
        "availability": 1
    },
    {
        "data": "2021-12-10",
        "origin": "BRC",
        "destination": "EPA",
        "price": 444.01,
        "availability": 9
    },
    {
        "data": "2022-04-24",
        "origin": "COR",
        "destination": "MDZ",
        "price": 376.53,
        "availability": 1
    },
    {
        "data": "2022-04-24",
        "origin": "COR",
        "destination": "BRC",
        "price": 472.46,
        "availability": 8
    },
    {
        "data": "2022-04-24",
        "origin": "EPA",
        "destination": "BRC",
        "price": 333.58,
        "availability": 5
    },
    {
        "data": "2021-11-25",
        "origin": "MDZ",
        "destination": "COR",
        "price": 191.48,
        "availability": 7
    },
    {
        "data": "2021-11-25",
        "origin": "BRC",
        "destination": "COR",
        "price": 397.48,
        "availability": 8
    },
    {
        "data": "2021-11-25",
        "origin": "BRC",
        "destination": "EPA",
        "price": 419.17,
        "availability": 2
    },
    {
        "data": "2022-04-26",
        "origin": "COR",
        "destination": "MDZ",
        "price": 317.97,
        "availability": 2
    },
    {
        "data": "2022-04-26",
        "origin": "COR",
        "destination": "BRC",
        "price": 448.66,
        "availability": 3
    },
    {
        "data": "2022-04-26",
        "origin": "EPA",
        "destination": "BRC",
        "price": 288.92,
        "availability": 9
    },
    {
        "data": "2021-11-26",
        "origin": "MDZ",
        "destination": "COR",
        "price": 393.14,
        "availability": 1
    },
    {
        "data": "2021-11-26",
        "origin": "BRC",
        "destination": "COR",
        "price": 188.78,
        "availability": 5
    },
    {
        "data": "2021-11-26",
        "origin": "BRC",
        "destination": "EPA",
        "price": 402.6,
        "availability": 1
    },
    {
        "data": "2022-05-06",
        "origin": "COR",
        "destination": "MDZ",
        "price": 249.55,
        "availability": 6
    },
    {
        "data": "2022-05-06",
        "origin": "COR",
        "destination": "BRC",
        "price": 425.68,
        "availability": 5
    },
    {
        "data": "2022-05-06",
        "origin": "EPA",
        "destination": "BRC",
        "price": 159.78,
        "availability": 8
    },
    {
        "data": "2021-12-30",
        "origin": "MDZ",
        "destination": "COR",
        "price": 260.27,
        "availability": 4
    },
    {
        "data": "2021-12-30",
        "origin": "BRC",
        "destination": "COR",
        "price": 398.07,
        "availability": 5
    },
    {
        "data": "2021-12-30",
        "origin": "BRC",
        "destination": "EPA",
        "price": 161.17,
        "availability": 9
    },
    {
        "data": "2022-04-15",
        "origin": "COR",
        "destination": "MDZ",
        "price": 378.12,
        "availability": 7
    },
    {
        "data": "2022-04-15",
        "origin": "COR",
        "destination": "BRC",
        "price": 453.28,
        "availability": 8
    },
    {
        "data": "2022-04-15",
        "origin": "EPA",
        "destination": "BRC",
        "price": 156.2,
        "availability": 4
    },
    {
        "data": "2021-12-22",
        "origin": "MDZ",
        "destination": "COR",
        "price": 319.16,
        "availability": 9
    },
    {
        "data": "2021-12-22",
        "origin": "BRC",
        "destination": "COR",
        "price": 205.65,
        "availability": 3
    },
    {
        "data": "2021-12-22",
        "origin": "BRC",
        "destination": "EPA",
        "price": 274.68,
        "availability": 7
    },
    {
        "data": "2021-11-20",
        "origin": "MDZ",
        "destination": "COR",
        "price": 187.66,
        "availability": 4
    },
    {
        "data": "2021-11-20",
        "origin": "BRC",
        "destination": "COR",
        "price": 482.7,
        "availability": 4
    },
    {
        "data": "2021-11-20",
        "origin": "BRC",
        "destination": "EPA",
        "price": 185.05,
        "availability": 8
    },
    {
        "data": "2021-12-02",
        "origin": "MDZ",
        "destination": "COR",
        "price": 475.32,
        "availability": 2
    },
    {
        "data": "2021-12-02",
        "origin": "BRC",
        "destination": "COR",
        "price": 159.69,
        "availability": 7
    },
    {
        "data": "2021-12-02",
        "origin": "BRC",
        "destination": "EPA",
        "price": 412.2,
        "availability": 5
    },
    {
        "data": "2022-05-05",
        "origin": "COR",
        "destination": "MDZ",
        "price": 460.24,
        "availability": 3
    },
    {
        "data": "2022-05-05",
        "origin": "COR",
        "destination": "BRC",
        "price": 168.51,
        "availability": 4
    },
    {
        "data": "2022-05-05",
        "origin": "EPA",
        "destination": "BRC",
        "price": 391.59,
        "availability": 5
    },
    {
        "data": "2021-12-11",
        "origin": "MDZ",
        "destination": "COR",
        "price": 493.06,
        "availability": 7
    },
    {
        "data": "2021-12-11",
        "origin": "BRC",
        "destination": "COR",
        "price": 312.18,
        "availability": 9
    },
    {
        "data": "2021-12-11",
        "origin": "BRC",
        "destination": "EPA",
        "price": 200.46,
        "availability": 2
    },
    {
        "data": "2021-11-21",
        "origin": "MDZ",
        "destination": "COR",
        "price": 448.23,
        "availability": 7
    },
    {
        "data": "2021-11-21",
        "origin": "BRC",
        "destination": "COR",
        "price": 459.27,
        "availability": 2
    },
    {
        "data": "2021-11-21",
        "origin": "BRC",
        "destination": "EPA",
        "price": 456.06,
        "availability": 8
    },
    {
        "data": "2022-01-03",
        "origin": "MDZ",
        "destination": "COR",
        "price": 364.08,
        "availability": 9
    },
    {
        "data": "2022-01-03",
        "origin": "BRC",
        "destination": "COR",
        "price": 318.58,
        "availability": 8
    },
    {
        "data": "2022-01-03",
        "origin": "BRC",
        "destination": "EPA",
        "price": 412.37,
        "availability": 1
    },
    {
        "data": "2022-04-27",
        "origin": "COR",
        "destination": "MDZ",
        "price": 312.54,
        "availability": 5
    },
    {
        "data": "2022-04-27",
        "origin": "COR",
        "destination": "BRC",
        "price": 494.35,
        "availability": 6
    },
    {
        "data": "2022-04-27",
        "origin": "EPA",
        "destination": "BRC",
        "price": 308.7,
        "availability": 5
    },
    {
        "data": "2022-01-01",
        "origin": "MDZ",
        "destination": "COR",
        "price": 449.14,
        "availability": 3
    },
    {
        "data": "2022-01-01",
        "origin": "BRC",
        "destination": "COR",
        "price": 346.91,
        "availability": 9
    },
    {
        "data": "2022-01-01",
        "origin": "BRC",
        "destination": "EPA",
        "price": 216.37,
        "availability": 6
    },
    {
        "data": "2021-11-28",
        "origin": "MDZ",
        "destination": "COR",
        "price": 273.76,
        "availability": 9
    },
    {
        "data": "2021-11-28",
        "origin": "BRC",
        "destination": "COR",
        "price": 188.74,
        "availability": 8
    },
    {
        "data": "2021-11-28",
        "origin": "BRC",
        "destination": "EPA",
        "price": 305.88,
        "availability": 8
    },
    {
        "data": "2021-12-13",
        "origin": "MDZ",
        "destination": "COR",
        "price": 259.43,
        "availability": 1
    },
    {
        "data": "2021-12-13",
        "origin": "BRC",
        "destination": "COR",
        "price": 376.8,
        "availability": 2
    },
    {
        "data": "2021-12-13",
        "origin": "BRC",
        "destination": "EPA",
        "price": 243.59,
        "availability": 5
    },
    {
        "data": "2021-11-19",
        "origin": "MDZ",
        "destination": "COR",
        "price": 154.62,
        "availability": 4
    },
    {
        "data": "2021-11-19",
        "origin": "BRC",
        "destination": "COR",
        "price": 483.41,
        "availability": 4
    },
    {
        "data": "2021-11-19",
        "origin": "BRC",
        "destination": "EPA",
        "price": 316.86,
        "availability": 2
    },
    {
        "data": "2021-12-23",
        "origin": "MDZ",
        "destination": "COR",
        "price": 395.44,
        "availability": 9
    },
    {
        "data": "2021-12-23",
        "origin": "BRC",
        "destination": "COR",
        "price": 428.94,
        "availability": 4
    },
    {
        "data": "2021-12-23",
        "origin": "BRC",
        "destination": "EPA",
        "price": 498.53,
        "availability": 1
    },
    {
        "data": "2021-11-29",
        "origin": "MDZ",
        "destination": "COR",
        "price": 371.58,
        "availability": 9
    },
    {
        "data": "2021-11-29",
        "origin": "BRC",
        "destination": "COR",
        "price": 359.45,
        "availability": 6
    },
    {
        "data": "2021-11-29",
        "origin": "BRC",
        "destination": "EPA",
        "price": 191.29,
        "availability": 5
    },
    {
        "data": "2022-01-12",
        "origin": "MDZ",
        "destination": "COR",
        "price": 339.86,
        "availability": 7
    },
    {
        "data": "2022-01-12",
        "origin": "BRC",
        "destination": "COR",
        "price": 244.57,
        "availability": 7
    },
    {
        "data": "2022-01-12",
        "origin": "BRC",
        "destination": "EPA",
        "price": 470.22,
        "availability": 7
    },
    {
        "data": "2022-05-04",
        "origin": "COR",
        "destination": "MDZ",
        "price": 390.76,
        "availability": 3
    },
    {
        "data": "2022-05-04",
        "origin": "COR",
        "destination": "BRC",
        "price": 288.26,
        "availability": 7
    },
    {
        "data": "2022-05-04",
        "origin": "EPA",
        "destination": "BRC",
        "price": 378.17,
        "availability": 8
    },
    {
        "data": "2022-01-10",
        "origin": "MDZ",
        "destination": "COR",
        "price": 468.53,
        "availability": 2
    },
    {
        "data": "2022-01-10",
        "origin": "BRC",
        "destination": "COR",
        "price": 294.35,
        "availability": 7
    },
    {
        "data": "2022-01-10",
        "origin": "BRC",
        "destination": "EPA",
        "price": 328.79,
        "availability": 4
    },
    {
        "data": "2021-12-06",
        "origin": "MDZ",
        "destination": "COR",
        "price": 440.5,
        "availability": 1
    },
    {
        "data": "2021-12-06",
        "origin": "BRC",
        "destination": "COR",
        "price": 228.01,
        "availability": 7
    },
    {
        "data": "2021-12-06",
        "origin": "BRC",
        "destination": "EPA",
        "price": 422.39,
        "availability": 3
    },
    {
        "data": "2021-12-20",
        "origin": "MDZ",
        "destination": "COR",
        "price": 452.2,
        "availability": 4
    },
    {
        "data": "2021-12-20",
        "origin": "BRC",
        "destination": "COR",
        "price": 284.98,
        "availability": 1
    },
    {
        "data": "2021-12-20",
        "origin": "BRC",
        "destination": "EPA",
        "price": 487.75,
        "availability": 7
    },
    {
        "data": "2021-11-23",
        "origin": "MDZ",
        "destination": "COR",
        "price": 476.29,
        "availability": 3
    },
    {
        "data": "2021-11-23",
        "origin": "BRC",
        "destination": "COR",
        "price": 281.36,
        "availability": 2
    },
    {
        "data": "2021-11-23",
        "origin": "BRC",
        "destination": "EPA",
        "price": 266.15,
        "availability": 3
    },
    {
        "data": "2022-01-11",
        "origin": "MDZ",
        "destination": "COR",
        "price": 294.54,
        "availability": 6
    },
    {
        "data": "2022-01-11",
        "origin": "BRC",
        "destination": "COR",
        "price": 174.97,
        "availability": 2
    },
    {
        "data": "2022-01-11",
        "origin": "BRC",
        "destination": "EPA",
        "price": 268.75,
        "availability": 4
    },
    {
        "data": "2021-11-30",
        "origin": "MDZ",
        "destination": "COR",
        "price": 362.58,
        "availability": 3
    },
    {
        "data": "2021-11-30",
        "origin": "BRC",
        "destination": "COR",
        "price": 235.64,
        "availability": 8
    },
    {
        "data": "2021-11-30",
        "origin": "BRC",
        "destination": "EPA",
        "price": 282.69,
        "availability": 6
    },
    {
        "data": "2022-01-20",
        "origin": "MDZ",
        "destination": "COR",
        "price": 171.93,
        "availability": 2
    },
    {
        "data": "2022-01-20",
        "origin": "BRC",
        "destination": "COR",
        "price": 494.91,
        "availability": 3
    },
    {
        "data": "2022-01-20",
        "origin": "BRC",
        "destination": "EPA",
        "price": 212.83,
        "availability": 9
    },
    {
        "data": "2021-11-18",
        "origin": "MDZ",
        "destination": "COR",
        "price": 453.72,
        "availability": 4
    },
    {
        "data": "2021-11-18",
        "origin": "BRC",
        "destination": "COR",
        "price": 374.69,
        "availability": 7
    },
    {
        "data": "2021-11-18",
        "origin": "BRC",
        "destination": "EPA",
        "price": 279.32,
        "availability": 2
    },
    {
        "data": "2022-01-23",
        "origin": "MDZ",
        "destination": "COR",
        "price": 175.63,
        "availability": 4
    },
    {
        "data": "2022-01-23",
        "origin": "BRC",
        "destination": "COR",
        "price": 242.08,
        "availability": 9
    },
    {
        "data": "2022-01-23",
        "origin": "BRC",
        "destination": "EPA",
        "price": 474.83,
        "availability": 1
    },
    {
        "data": "2021-12-17",
        "origin": "MDZ",
        "destination": "COR",
        "price": 419.09,
        "availability": 6
    },
    {
        "data": "2021-12-17",
        "origin": "BRC",
        "destination": "COR",
        "price": 451.27,
        "availability": 7
    },
    {
        "data": "2021-12-17",
        "origin": "BRC",
        "destination": "EPA",
        "price": 398.81,
        "availability": 1
    },
    {
        "data": "2021-12-31",
        "origin": "MDZ",
        "destination": "COR",
        "price": 403.45,
        "availability": 2
    },
    {
        "data": "2021-12-31",
        "origin": "BRC",
        "destination": "COR",
        "price": 294.93,
        "availability": 1
    },
    {
        "data": "2021-12-31",
        "origin": "BRC",
        "destination": "EPA",
        "price": 196.13,
        "availability": 2
    },
    {
        "data": "2021-12-04",
        "origin": "MDZ",
        "destination": "COR",
        "price": 415.15,
        "availability": 6
    },
    {
        "data": "2021-12-04",
        "origin": "BRC",
        "destination": "COR",
        "price": 292.81,
        "availability": 7
    },
    {
        "data": "2021-12-04",
        "origin": "BRC",
        "destination": "EPA",
        "price": 438.83,
        "availability": 8
    },
    {
        "data": "2022-01-22",
        "origin": "MDZ",
        "destination": "COR",
        "price": 460.83,
        "availability": 5
    },
    {
        "data": "2022-01-22",
        "origin": "BRC",
        "destination": "COR",
        "price": 466.55,
        "availability": 6
    },
    {
        "data": "2022-01-22",
        "origin": "BRC",
        "destination": "EPA",
        "price": 187.62,
        "availability": 1
    },
    {
        "data": "2021-12-07",
        "origin": "MDZ",
        "destination": "COR",
        "price": 290.25,
        "availability": 7
    },
    {
        "data": "2021-12-07",
        "origin": "BRC",
        "destination": "COR",
        "price": 376.51,
        "availability": 4
    },
    {
        "data": "2021-12-07",
        "origin": "BRC",
        "destination": "EPA",
        "price": 385.19,
        "availability": 1
    },
    {
        "data": "2022-01-31",
        "origin": "MDZ",
        "destination": "COR",
        "price": 378.43,
        "availability": 5
    },
    {
        "data": "2022-01-31",
        "origin": "BRC",
        "destination": "COR",
        "price": 366.47,
        "availability": 4
    },
    {
        "data": "2022-01-31",
        "origin": "BRC",
        "destination": "EPA",
        "price": 200.35,
        "availability": 5
    },
    {
        "data": "2021-11-22",
        "origin": "MDZ",
        "destination": "COR",
        "price": 333.85,
        "availability": 3
    },
    {
        "data": "2021-11-22",
        "origin": "BRC",
        "destination": "COR",
        "price": 407.8,
        "availability": 9
    },
    {
        "data": "2021-11-22",
        "origin": "BRC",
        "destination": "EPA",
        "price": 239.6,
        "availability": 5
    },
    {
        "data": "2022-02-03",
        "origin": "MDZ",
        "destination": "COR",
        "price": 400.04,
        "availability": 3
    },
    {
        "data": "2022-02-03",
        "origin": "BRC",
        "destination": "COR",
        "price": 445.84,
        "availability": 1
    },
    {
        "data": "2022-02-03",
        "origin": "BRC",
        "destination": "EPA",
        "price": 218.1,
        "availability": 5
    },
    {
        "data": "2021-12-24",
        "origin": "MDZ",
        "destination": "COR",
        "price": 379.9,
        "availability": 6
    },
    {
        "data": "2021-12-24",
        "origin": "BRC",
        "destination": "COR",
        "price": 217.21,
        "availability": 8
    },
    {
        "data": "2021-12-24",
        "origin": "BRC",
        "destination": "EPA",
        "price": 187.62,
        "availability": 4
    },
    {
        "data": "2022-01-02",
        "origin": "MDZ",
        "destination": "COR",
        "price": 485.08,
        "availability": 5
    },
    {
        "data": "2022-01-02",
        "origin": "BRC",
        "destination": "COR",
        "price": 385.6,
        "availability": 8
    },
    {
        "data": "2022-01-02",
        "origin": "BRC",
        "destination": "EPA",
        "price": 291.42,
        "availability": 7
    },
    {
        "data": "2021-12-08",
        "origin": "MDZ",
        "destination": "COR",
        "price": 328.58,
        "availability": 4
    },
    {
        "data": "2021-12-08",
        "origin": "BRC",
        "destination": "COR",
        "price": 436.55,
        "availability": 7
    },
    {
        "data": "2021-12-08",
        "origin": "BRC",
        "destination": "EPA",
        "price": 486.3,
        "availability": 3
    },
    {
        "data": "2022-02-02",
        "origin": "MDZ",
        "destination": "COR",
        "price": 285.21,
        "availability": 4
    },
    {
        "data": "2022-02-02",
        "origin": "BRC",
        "destination": "COR",
        "price": 488.91,
        "availability": 6
    },
    {
        "data": "2022-02-02",
        "origin": "BRC",
        "destination": "EPA",
        "price": 426.47,
        "availability": 3
    },
    {
        "data": "2021-12-16",
        "origin": "MDZ",
        "destination": "COR",
        "price": 223.48,
        "availability": 6
    },
    {
        "data": "2021-12-16",
        "origin": "BRC",
        "destination": "COR",
        "price": 470.92,
        "availability": 7
    },
    {
        "data": "2021-12-16",
        "origin": "BRC",
        "destination": "EPA",
        "price": 448.63,
        "availability": 6
    },
    {
        "data": "2022-02-01",
        "origin": "MDZ",
        "destination": "COR",
        "price": 208.12,
        "availability": 6
    },
    {
        "data": "2022-02-01",
        "origin": "BRC",
        "destination": "COR",
        "price": 185.79,
        "availability": 9
    },
    {
        "data": "2022-02-01",
        "origin": "BRC",
        "destination": "EPA",
        "price": 499.12,
        "availability": 5
    },
    {
        "data": "2021-12-05",
        "origin": "MDZ",
        "destination": "COR",
        "price": 438.92,
        "availability": 9
    },
    {
        "data": "2021-12-05",
        "origin": "BRC",
        "destination": "COR",
        "price": 415.33,
        "availability": 1
    },
    {
        "data": "2021-12-05",
        "origin": "BRC",
        "destination": "EPA",
        "price": 339.8,
        "availability": 7
    },
    {
        "data": "2022-02-12",
        "origin": "MDZ",
        "destination": "COR",
        "price": 255.04,
        "availability": 9
    },
    {
        "data": "2022-02-12",
        "origin": "BRC",
        "destination": "COR",
        "price": 260.46,
        "availability": 4
    },
    {
        "data": "2022-02-12",
        "origin": "BRC",
        "destination": "EPA",
        "price": 320,
        "availability": 7
    },
    {
        "data": "2021-12-28",
        "origin": "MDZ",
        "destination": "COR",
        "price": 394.49,
        "availability": 4
    },
    {
        "data": "2021-12-28",
        "origin": "BRC",
        "destination": "COR",
        "price": 388.11,
        "availability": 7
    },
    {
        "data": "2021-12-28",
        "origin": "BRC",
        "destination": "EPA",
        "price": 392.37,
        "availability": 8
    },
    {
        "data": "2022-01-13",
        "origin": "MDZ",
        "destination": "COR",
        "price": 159.51,
        "availability": 9
    },
    {
        "data": "2022-01-13",
        "origin": "BRC",
        "destination": "COR",
        "price": 466.15,
        "availability": 9
    },
    {
        "data": "2022-01-13",
        "origin": "BRC",
        "destination": "EPA",
        "price": 473.75,
        "availability": 7
    },
    {
        "data": "2021-12-15",
        "origin": "MDZ",
        "destination": "COR",
        "price": 245.71,
        "availability": 8
    },
    {
        "data": "2021-12-15",
        "origin": "BRC",
        "destination": "COR",
        "price": 162.25,
        "availability": 3
    },
    {
        "data": "2021-12-15",
        "origin": "BRC",
        "destination": "EPA",
        "price": 458.52,
        "availability": 2
    },
    {
        "data": "2022-02-13",
        "origin": "MDZ",
        "destination": "COR",
        "price": 358.34,
        "availability": 9
    },
    {
        "data": "2022-02-13",
        "origin": "BRC",
        "destination": "COR",
        "price": 210.9,
        "availability": 4
    },
    {
        "data": "2022-02-13",
        "origin": "BRC",
        "destination": "EPA",
        "price": 246.55,
        "availability": 8
    },
    {
        "data": "2021-12-25",
        "origin": "MDZ",
        "destination": "COR",
        "price": 323.01,
        "availability": 8
    },
    {
        "data": "2021-12-25",
        "origin": "BRC",
        "destination": "COR",
        "price": 408.09,
        "availability": 4
    },
    {
        "data": "2021-12-25",
        "origin": "BRC",
        "destination": "EPA",
        "price": 340.08,
        "availability": 2
    },
    {
        "data": "2022-02-10",
        "origin": "MDZ",
        "destination": "COR",
        "price": 375.58,
        "availability": 3
    },
    {
        "data": "2022-02-10",
        "origin": "BRC",
        "destination": "COR",
        "price": 154.51,
        "availability": 7
    },
    {
        "data": "2022-02-10",
        "origin": "BRC",
        "destination": "EPA",
        "price": 215.63,
        "availability": 5
    },
    {
        "data": "2021-12-09",
        "origin": "MDZ",
        "destination": "COR",
        "price": 391,
        "availability": 2
    },
    {
        "data": "2021-12-09",
        "origin": "BRC",
        "destination": "COR",
        "price": 180.15,
        "availability": 6
    },
    {
        "data": "2021-12-09",
        "origin": "BRC",
        "destination": "EPA",
        "price": 463.06,
        "availability": 5
    },
    {
        "data": "2022-02-27",
        "origin": "MDZ",
        "destination": "COR",
        "price": 330.55,
        "availability": 9
    },
    {
        "data": "2022-02-27",
        "origin": "BRC",
        "destination": "COR",
        "price": 165.91,
        "availability": 9
    },
    {
        "data": "2022-02-27",
        "origin": "BRC",
        "destination": "EPA",
        "price": 428.67,
        "availability": 1
    },
    {
        "data": "2022-01-06",
        "origin": "MDZ",
        "destination": "COR",
        "price": 358.32,
        "availability": 6
    },
    {
        "data": "2022-01-06",
        "origin": "BRC",
        "destination": "COR",
        "price": 497.24,
        "availability": 5
    },
    {
        "data": "2022-01-06",
        "origin": "BRC",
        "destination": "EPA",
        "price": 245.27,
        "availability": 3
    },
    {
        "data": "2022-01-21",
        "origin": "MDZ",
        "destination": "COR",
        "price": 270.27,
        "availability": 4
    },
    {
        "data": "2022-01-21",
        "origin": "BRC",
        "destination": "COR",
        "price": 499.4,
        "availability": 3
    },
    {
        "data": "2022-01-21",
        "origin": "BRC",
        "destination": "EPA",
        "price": 374.31,
        "availability": 1
    },
    {
        "data": "2021-12-19",
        "origin": "MDZ",
        "destination": "COR",
        "price": 421.31,
        "availability": 2
    },
    {
        "data": "2021-12-19",
        "origin": "BRC",
        "destination": "COR",
        "price": 406.43,
        "availability": 1
    },
    {
        "data": "2021-12-19",
        "origin": "BRC",
        "destination": "EPA",
        "price": 414.56,
        "availability": 7
    },
    {
        "data": "2022-02-26",
        "origin": "MDZ",
        "destination": "COR",
        "price": 453.42,
        "availability": 2
    },
    {
        "data": "2022-02-26",
        "origin": "BRC",
        "destination": "COR",
        "price": 390.69,
        "availability": 4
    },
    {
        "data": "2022-02-26",
        "origin": "BRC",
        "destination": "EPA",
        "price": 324.26,
        "availability": 6
    },
    {
        "data": "2021-12-29",
        "origin": "MDZ",
        "destination": "COR",
        "price": 174.63,
        "availability": 3
    },
    {
        "data": "2021-12-29",
        "origin": "BRC",
        "destination": "COR",
        "price": 426.81,
        "availability": 4
    },
    {
        "data": "2021-12-29",
        "origin": "BRC",
        "destination": "EPA",
        "price": 374.1,
        "availability": 1
    },
    {
        "data": "2022-02-24",
        "origin": "MDZ",
        "destination": "COR",
        "price": 453.17,
        "availability": 9
    },
    {
        "data": "2022-02-24",
        "origin": "BRC",
        "destination": "COR",
        "price": 489.12,
        "availability": 5
    },
    {
        "data": "2022-02-24",
        "origin": "BRC",
        "destination": "EPA",
        "price": 493.46,
        "availability": 9
    },
    {
        "data": "2021-12-14",
        "origin": "MDZ",
        "destination": "COR",
        "price": 158.29,
        "availability": 4
    },
    {
        "data": "2021-12-14",
        "origin": "BRC",
        "destination": "COR",
        "price": 271.33,
        "availability": 8
    },
    {
        "data": "2021-12-14",
        "origin": "BRC",
        "destination": "EPA",
        "price": 439.83,
        "availability": 8
    },
    {
        "data": "2022-03-02",
        "origin": "MDZ",
        "destination": "COR",
        "price": 187.44,
        "availability": 5
    },
    {
        "data": "2022-03-02",
        "origin": "BRC",
        "destination": "COR",
        "price": 257.84,
        "availability": 4
    },
    {
        "data": "2022-03-02",
        "origin": "BRC",
        "destination": "EPA",
        "price": 358.06,
        "availability": 1
    },
    {
        "data": "2022-01-17",
        "origin": "MDZ",
        "destination": "COR",
        "price": 289.59,
        "availability": 8
    },
    {
        "data": "2022-01-17",
        "origin": "BRC",
        "destination": "COR",
        "price": 466.61,
        "availability": 5
    },
    {
        "data": "2022-01-17",
        "origin": "BRC",
        "destination": "EPA",
        "price": 411.58,
        "availability": 6
    },
    {
        "data": "2022-01-30",
        "origin": "MDZ",
        "destination": "COR",
        "price": 348.88,
        "availability": 6
    },
    {
        "data": "2022-01-30",
        "origin": "BRC",
        "destination": "COR",
        "price": 427.07,
        "availability": 8
    },
    {
        "data": "2022-01-30",
        "origin": "BRC",
        "destination": "EPA",
        "price": 158.3,
        "availability": 2
    },
    {
        "data": "2021-12-27",
        "origin": "MDZ",
        "destination": "COR",
        "price": 419.89,
        "availability": 4
    },
    {
        "data": "2021-12-27",
        "origin": "BRC",
        "destination": "COR",
        "price": 467.55,
        "availability": 6
    },
    {
        "data": "2021-12-27",
        "origin": "BRC",
        "destination": "EPA",
        "price": 297.13,
        "availability": 1
    },
    {
        "data": "2022-03-03",
        "origin": "MDZ",
        "destination": "COR",
        "price": 393.24,
        "availability": 1
    },
    {
        "data": "2022-03-03",
        "origin": "BRC",
        "destination": "COR",
        "price": 333.38,
        "availability": 8
    },
    {
        "data": "2022-03-03",
        "origin": "BRC",
        "destination": "EPA",
        "price": 158.32,
        "availability": 8
    },
    {
        "data": "2022-01-07",
        "origin": "MDZ",
        "destination": "COR",
        "price": 439.73,
        "availability": 1
    },
    {
        "data": "2022-01-07",
        "origin": "BRC",
        "destination": "COR",
        "price": 412.05,
        "availability": 2
    },
    {
        "data": "2022-01-07",
        "origin": "BRC",
        "destination": "EPA",
        "price": 194.93,
        "availability": 5
    },
    {
        "data": "2022-02-28",
        "origin": "MDZ",
        "destination": "COR",
        "price": 367.83,
        "availability": 4
    },
    {
        "data": "2022-02-28",
        "origin": "BRC",
        "destination": "COR",
        "price": 493.34,
        "availability": 2
    },
    {
        "data": "2022-02-28",
        "origin": "BRC",
        "destination": "EPA",
        "price": 324.47,
        "availability": 6
    },
    {
        "data": "2021-12-18",
        "origin": "MDZ",
        "destination": "COR",
        "price": 491.42,
        "availability": 7
    },
    {
        "data": "2021-12-18",
        "origin": "BRC",
        "destination": "COR",
        "price": 203.27,
        "availability": 5
    },
    {
        "data": "2021-12-18",
        "origin": "BRC",
        "destination": "EPA",
        "price": 486.6,
        "availability": 8
    },
    {
        "data": "2022-03-13",
        "origin": "MDZ",
        "destination": "COR",
        "price": 183.18,
        "availability": 6
    },
    {
        "data": "2022-03-13",
        "origin": "BRC",
        "destination": "COR",
        "price": 460.4,
        "availability": 7
    },
    {
        "data": "2022-03-13",
        "origin": "BRC",
        "destination": "EPA",
        "price": 204.3,
        "availability": 4
    },
    {
        "data": "2022-01-25",
        "origin": "MDZ",
        "destination": "COR",
        "price": 164.63,
        "availability": 2
    },
    {
        "data": "2022-01-25",
        "origin": "BRC",
        "destination": "COR",
        "price": 492.63,
        "availability": 3
    },
    {
        "data": "2022-01-25",
        "origin": "BRC",
        "destination": "EPA",
        "price": 459.99,
        "availability": 1
    },
    {
        "data": "2022-02-11",
        "origin": "MDZ",
        "destination": "COR",
        "price": 333.31,
        "availability": 4
    },
    {
        "data": "2022-02-11",
        "origin": "BRC",
        "destination": "COR",
        "price": 370.54,
        "availability": 6
    },
    {
        "data": "2022-02-11",
        "origin": "BRC",
        "destination": "EPA",
        "price": 436.9,
        "availability": 8
    },
    {
        "data": "2022-01-04",
        "origin": "MDZ",
        "destination": "COR",
        "price": 236.68,
        "availability": 7
    },
    {
        "data": "2022-01-04",
        "origin": "BRC",
        "destination": "COR",
        "price": 201.25,
        "availability": 9
    },
    {
        "data": "2022-01-04",
        "origin": "BRC",
        "destination": "EPA",
        "price": 283.04,
        "availability": 2
    },
    {
        "data": "2022-03-12",
        "origin": "MDZ",
        "destination": "COR",
        "price": 247.7,
        "availability": 3
    },
    {
        "data": "2022-03-12",
        "origin": "BRC",
        "destination": "COR",
        "price": 246.49,
        "availability": 6
    },
    {
        "data": "2022-03-12",
        "origin": "BRC",
        "destination": "EPA",
        "price": 318.21,
        "availability": 8
    },
    {
        "data": "2022-01-16",
        "origin": "MDZ",
        "destination": "COR",
        "price": 385.58,
        "availability": 4
    },
    {
        "data": "2022-01-16",
        "origin": "BRC",
        "destination": "COR",
        "price": 273.04,
        "availability": 3
    },
    {
        "data": "2022-01-16",
        "origin": "BRC",
        "destination": "EPA",
        "price": 429.79,
        "availability": 5
    },
    {
        "data": "2022-03-01",
        "origin": "MDZ",
        "destination": "COR",
        "price": 187,
        "availability": 8
    },
    {
        "data": "2022-03-01",
        "origin": "BRC",
        "destination": "COR",
        "price": 271.77,
        "availability": 3
    },
    {
        "data": "2022-03-01",
        "origin": "BRC",
        "destination": "EPA",
        "price": 266.63,
        "availability": 7
    },
    {
        "data": "2021-12-26",
        "origin": "MDZ",
        "destination": "COR",
        "price": 273.96,
        "availability": 5
    },
    {
        "data": "2021-12-26",
        "origin": "BRC",
        "destination": "COR",
        "price": 371.27,
        "availability": 4
    },
    {
        "data": "2021-12-26",
        "origin": "BRC",
        "destination": "EPA",
        "price": 238.13,
        "availability": 2
    },
    {
        "data": "2022-03-21",
        "origin": "MDZ",
        "destination": "COR",
        "price": 311.51,
        "availability": 4
    },
    {
        "data": "2022-03-21",
        "origin": "BRC",
        "destination": "COR",
        "price": 249.71,
        "availability": 7
    },
    {
        "data": "2022-03-21",
        "origin": "BRC",
        "destination": "EPA",
        "price": 292.18,
        "availability": 5
    },
    {
        "data": "2022-01-29",
        "origin": "MDZ",
        "destination": "COR",
        "price": 183.98,
        "availability": 8
    },
    {
        "data": "2022-01-29",
        "origin": "BRC",
        "destination": "COR",
        "price": 489.59,
        "availability": 5
    },
    {
        "data": "2022-01-29",
        "origin": "BRC",
        "destination": "EPA",
        "price": 431.08,
        "availability": 6
    },
    {
        "data": "2022-02-25",
        "origin": "MDZ",
        "destination": "COR",
        "price": 432.28,
        "availability": 6
    },
    {
        "data": "2022-02-25",
        "origin": "BRC",
        "destination": "COR",
        "price": 369.04,
        "availability": 5
    },
    {
        "data": "2022-02-25",
        "origin": "BRC",
        "destination": "EPA",
        "price": 335.36,
        "availability": 1
    },
    {
        "data": "2022-01-08",
        "origin": "MDZ",
        "destination": "COR",
        "price": 460.03,
        "availability": 8
    },
    {
        "data": "2022-01-08",
        "origin": "BRC",
        "destination": "COR",
        "price": 296.3,
        "availability": 9
    },
    {
        "data": "2022-01-08",
        "origin": "BRC",
        "destination": "EPA",
        "price": 192.22,
        "availability": 1
    },
    {
        "data": "2022-03-20",
        "origin": "MDZ",
        "destination": "COR",
        "price": 224.33,
        "availability": 9
    },
    {
        "data": "2022-03-20",
        "origin": "BRC",
        "destination": "COR",
        "price": 192.09,
        "availability": 6
    },
    {
        "data": "2022-03-20",
        "origin": "BRC",
        "destination": "EPA",
        "price": 371.97,
        "availability": 1
    },
    {
        "data": "2022-01-24",
        "origin": "MDZ",
        "destination": "COR",
        "price": 499.71,
        "availability": 9
    },
    {
        "data": "2022-01-24",
        "origin": "BRC",
        "destination": "COR",
        "price": 326.34,
        "availability": 5
    },
    {
        "data": "2022-01-24",
        "origin": "BRC",
        "destination": "EPA",
        "price": 318.92,
        "availability": 8
    },
    {
        "data": "2022-03-10",
        "origin": "MDZ",
        "destination": "COR",
        "price": 321.01,
        "availability": 9
    },
    {
        "data": "2022-03-10",
        "origin": "BRC",
        "destination": "COR",
        "price": 405.11,
        "availability": 7
    },
    {
        "data": "2022-03-10",
        "origin": "BRC",
        "destination": "EPA",
        "price": 457.47,
        "availability": 1
    },
    {
        "data": "2022-01-05",
        "origin": "MDZ",
        "destination": "COR",
        "price": 172.02,
        "availability": 3
    },
    {
        "data": "2022-01-05",
        "origin": "BRC",
        "destination": "COR",
        "price": 435.12,
        "availability": 1
    },
    {
        "data": "2022-01-05",
        "origin": "BRC",
        "destination": "EPA",
        "price": 373.31,
        "availability": 2
    },
    {
        "data": "2022-03-30",
        "origin": "MDZ",
        "destination": "COR",
        "price": 341.61,
        "availability": 9
    },
    {
        "data": "2022-03-30",
        "origin": "BRC",
        "destination": "COR",
        "price": 439.11,
        "availability": 2
    },
    {
        "data": "2022-03-30",
        "origin": "BRC",
        "destination": "EPA",
        "price": 185.86,
        "availability": 3
    },
    {
        "data": "2022-02-07",
        "origin": "MDZ",
        "destination": "COR",
        "price": 194.91,
        "availability": 5
    },
    {
        "data": "2022-02-07",
        "origin": "BRC",
        "destination": "COR",
        "price": 154.51,
        "availability": 2
    },
    {
        "data": "2022-02-07",
        "origin": "BRC",
        "destination": "EPA",
        "price": 234.53,
        "availability": 3
    },
    {
        "data": "2022-03-11",
        "origin": "MDZ",
        "destination": "COR",
        "price": 168.14,
        "availability": 7
    },
    {
        "data": "2022-03-11",
        "origin": "BRC",
        "destination": "COR",
        "price": 350.59,
        "availability": 4
    },
    {
        "data": "2022-03-11",
        "origin": "BRC",
        "destination": "EPA",
        "price": 391.6,
        "availability": 5
    },
    {
        "data": "2022-01-15",
        "origin": "MDZ",
        "destination": "COR",
        "price": 340.84,
        "availability": 2
    },
    {
        "data": "2022-01-15",
        "origin": "BRC",
        "destination": "COR",
        "price": 483.9,
        "availability": 1
    },
    {
        "data": "2022-01-15",
        "origin": "BRC",
        "destination": "EPA",
        "price": 327.67,
        "availability": 8
    },
    {
        "data": "2022-03-31",
        "origin": "MDZ",
        "destination": "COR",
        "price": 170.05,
        "availability": 5
    },
    {
        "data": "2022-03-31",
        "origin": "BRC",
        "destination": "COR",
        "price": 207.92,
        "availability": 2
    },
    {
        "data": "2022-03-31",
        "origin": "BRC",
        "destination": "EPA",
        "price": 162.36,
        "availability": 8
    },
    {
        "data": "2022-01-28",
        "origin": "MDZ",
        "destination": "COR",
        "price": 337.78,
        "availability": 3
    },
    {
        "data": "2022-01-28",
        "origin": "BRC",
        "destination": "COR",
        "price": 266.86,
        "availability": 3
    },
    {
        "data": "2022-01-28",
        "origin": "BRC",
        "destination": "EPA",
        "price": 491.8,
        "availability": 2
    },
    {
        "data": "2022-03-23",
        "origin": "MDZ",
        "destination": "COR",
        "price": 260.59,
        "availability": 9
    },
    {
        "data": "2022-03-23",
        "origin": "BRC",
        "destination": "COR",
        "price": 162.87,
        "availability": 2
    },
    {
        "data": "2022-03-23",
        "origin": "BRC",
        "destination": "EPA",
        "price": 373.64,
        "availability": 2
    },
    {
        "data": "2022-01-09",
        "origin": "MDZ",
        "destination": "COR",
        "price": 194.37,
        "availability": 3
    },
    {
        "data": "2022-01-09",
        "origin": "BRC",
        "destination": "COR",
        "price": 439.08,
        "availability": 8
    },
    {
        "data": "2022-01-09",
        "origin": "BRC",
        "destination": "EPA",
        "price": 161.79,
        "availability": 9
    },
    {
        "data": "2022-04-06",
        "origin": "MDZ",
        "destination": "COR",
        "price": 303.23,
        "availability": 2
    },
    {
        "data": "2022-04-06",
        "origin": "BRC",
        "destination": "COR",
        "price": 162.97,
        "availability": 1
    },
    {
        "data": "2022-04-06",
        "origin": "BRC",
        "destination": "EPA",
        "price": 181.35,
        "availability": 9
    },
    {
        "data": "2022-02-16",
        "origin": "MDZ",
        "destination": "COR",
        "price": 369.74,
        "availability": 8
    },
    {
        "data": "2022-02-16",
        "origin": "BRC",
        "destination": "COR",
        "price": 294.01,
        "availability": 3
    },
    {
        "data": "2022-02-16",
        "origin": "BRC",
        "destination": "EPA",
        "price": 410.96,
        "availability": 7
    },
    {
        "data": "2022-03-22",
        "origin": "MDZ",
        "destination": "COR",
        "price": 203.52,
        "availability": 8
    },
    {
        "data": "2022-03-22",
        "origin": "BRC",
        "destination": "COR",
        "price": 250.9,
        "availability": 1
    },
    {
        "data": "2022-03-22",
        "origin": "BRC",
        "destination": "EPA",
        "price": 416.65,
        "availability": 6
    },
    {
        "data": "2022-01-19",
        "origin": "MDZ",
        "destination": "COR",
        "price": 422.95,
        "availability": 1
    },
    {
        "data": "2022-01-19",
        "origin": "BRC",
        "destination": "COR",
        "price": 326.13,
        "availability": 5
    },
    {
        "data": "2022-01-19",
        "origin": "BRC",
        "destination": "EPA",
        "price": 273.95,
        "availability": 1
    },
    {
        "data": "2022-04-07",
        "origin": "MDZ",
        "destination": "COR",
        "price": 301.14,
        "availability": 5
    },
    {
        "data": "2022-04-07",
        "origin": "BRC",
        "destination": "COR",
        "price": 344.04,
        "availability": 5
    },
    {
        "data": "2022-04-07",
        "origin": "BRC",
        "destination": "EPA",
        "price": 275.89,
        "availability": 7
    },
    {
        "data": "2022-02-06",
        "origin": "MDZ",
        "destination": "COR",
        "price": 385.67,
        "availability": 2
    },
    {
        "data": "2022-02-06",
        "origin": "BRC",
        "destination": "COR",
        "price": 273.9,
        "availability": 3
    },
    {
        "data": "2022-02-06",
        "origin": "BRC",
        "destination": "EPA",
        "price": 233.79,
        "availability": 4
    },
    {
        "data": "2022-04-04",
        "origin": "MDZ",
        "destination": "COR",
        "price": 176.12,
        "availability": 4
    },
    {
        "data": "2022-04-04",
        "origin": "BRC",
        "destination": "COR",
        "price": 221.84,
        "availability": 9
    },
    {
        "data": "2022-04-04",
        "origin": "BRC",
        "destination": "EPA",
        "price": 228.32,
        "availability": 1
    },
    {
        "data": "2022-01-14",
        "origin": "MDZ",
        "destination": "COR",
        "price": 472.66,
        "availability": 7
    },
    {
        "data": "2022-01-14",
        "origin": "BRC",
        "destination": "COR",
        "price": 311.49,
        "availability": 6
    },
    {
        "data": "2022-01-14",
        "origin": "BRC",
        "destination": "EPA",
        "price": 189.7,
        "availability": 6
    },
    {
        "data": "2022-04-17",
        "origin": "MDZ",
        "destination": "COR",
        "price": 430.2,
        "availability": 6
    },
    {
        "data": "2022-04-17",
        "origin": "BRC",
        "destination": "COR",
        "price": 424.53,
        "availability": 9
    },
    {
        "data": "2022-04-17",
        "origin": "BRC",
        "destination": "EPA",
        "price": 346.48,
        "availability": 6
    },
    {
        "data": "2022-02-23",
        "origin": "MDZ",
        "destination": "COR",
        "price": 349.63,
        "availability": 3
    },
    {
        "data": "2022-02-23",
        "origin": "BRC",
        "destination": "COR",
        "price": 340.25,
        "availability": 7
    },
    {
        "data": "2022-02-23",
        "origin": "BRC",
        "destination": "EPA",
        "price": 394.54,
        "availability": 3
    },
    {
        "data": "2022-04-05",
        "origin": "MDZ",
        "destination": "COR",
        "price": 343.3,
        "availability": 5
    },
    {
        "data": "2022-04-05",
        "origin": "BRC",
        "destination": "COR",
        "price": 181.93,
        "availability": 3
    },
    {
        "data": "2022-04-05",
        "origin": "BRC",
        "destination": "EPA",
        "price": 257.47,
        "availability": 2
    },
    {
        "data": "2022-01-26",
        "origin": "MDZ",
        "destination": "COR",
        "price": 431.41,
        "availability": 2
    },
    {
        "data": "2022-01-26",
        "origin": "BRC",
        "destination": "COR",
        "price": 380.41,
        "availability": 1
    },
    {
        "data": "2022-01-26",
        "origin": "BRC",
        "destination": "EPA",
        "price": 243.71,
        "availability": 7
    },
    {
        "data": "2022-04-16",
        "origin": "MDZ",
        "destination": "COR",
        "price": 467.34,
        "availability": 8
    },
    {
        "data": "2022-04-16",
        "origin": "BRC",
        "destination": "COR",
        "price": 150.24,
        "availability": 2
    },
    {
        "data": "2022-04-16",
        "origin": "BRC",
        "destination": "EPA",
        "price": 317.62,
        "availability": 6
    },
    {
        "data": "2022-02-17",
        "origin": "MDZ",
        "destination": "COR",
        "price": 287.16,
        "availability": 3
    },
    {
        "data": "2022-02-17",
        "origin": "BRC",
        "destination": "COR",
        "price": 404.54,
        "availability": 7
    },
    {
        "data": "2022-02-17",
        "origin": "BRC",
        "destination": "EPA",
        "price": 292.56,
        "availability": 9
    },
    {
        "data": "2022-04-08",
        "origin": "MDZ",
        "destination": "COR",
        "price": 294.83,
        "availability": 9
    },
    {
        "data": "2022-04-08",
        "origin": "BRC",
        "destination": "COR",
        "price": 346.22,
        "availability": 1
    },
    {
        "data": "2022-04-08",
        "origin": "BRC",
        "destination": "EPA",
        "price": 375.7,
        "availability": 6
    },
    {
        "data": "2022-01-18",
        "origin": "MDZ",
        "destination": "COR",
        "price": 158.14,
        "availability": 6
    },
    {
        "data": "2022-01-18",
        "origin": "BRC",
        "destination": "COR",
        "price": 440.07,
        "availability": 7
    },
    {
        "data": "2022-01-18",
        "origin": "BRC",
        "destination": "EPA",
        "price": 218.25,
        "availability": 4
    },
    {
        "data": "2022-04-24",
        "origin": "MDZ",
        "destination": "COR",
        "price": 411.03,
        "availability": 8
    },
    {
        "data": "2022-04-24",
        "origin": "BRC",
        "destination": "COR",
        "price": 187.38,
        "availability": 4
    },
    {
        "data": "2022-04-24",
        "origin": "BRC",
        "destination": "EPA",
        "price": 362.89,
        "availability": 1
    },
    {
        "data": "2022-03-06",
        "origin": "MDZ",
        "destination": "COR",
        "price": 396.79,
        "availability": 1
    },
    {
        "data": "2022-03-06",
        "origin": "BRC",
        "destination": "COR",
        "price": 350.25,
        "availability": 1
    },
    {
        "data": "2022-03-06",
        "origin": "BRC",
        "destination": "EPA",
        "price": 388.01,
        "availability": 9
    },
    {
        "data": "2022-04-09",
        "origin": "MDZ",
        "destination": "COR",
        "price": 320.86,
        "availability": 9
    },
    {
        "data": "2022-04-09",
        "origin": "BRC",
        "destination": "COR",
        "price": 482.47,
        "availability": 8
    },
    {
        "data": "2022-04-09",
        "origin": "BRC",
        "destination": "EPA",
        "price": 478.37,
        "availability": 8
    },
    {
        "data": "2022-02-04",
        "origin": "MDZ",
        "destination": "COR",
        "price": 336.86,
        "availability": 4
    },
    {
        "data": "2022-02-04",
        "origin": "BRC",
        "destination": "COR",
        "price": 264.93,
        "availability": 2
    },
    {
        "data": "2022-02-04",
        "origin": "BRC",
        "destination": "EPA",
        "price": 190.45,
        "availability": 5
    },
    {
        "data": "2022-04-25",
        "origin": "MDZ",
        "destination": "COR",
        "price": 478.59,
        "availability": 4
    },
    {
        "data": "2022-04-25",
        "origin": "BRC",
        "destination": "COR",
        "price": 462.68,
        "availability": 3
    },
    {
        "data": "2022-04-25",
        "origin": "BRC",
        "destination": "EPA",
        "price": 474.22,
        "availability": 8
    },
    {
        "data": "2022-02-22",
        "origin": "MDZ",
        "destination": "COR",
        "price": 311.9,
        "availability": 2
    },
    {
        "data": "2022-02-22",
        "origin": "BRC",
        "destination": "COR",
        "price": 246.4,
        "availability": 4
    },
    {
        "data": "2022-02-22",
        "origin": "BRC",
        "destination": "EPA",
        "price": 265.27,
        "availability": 7
    },
    {
        "data": "2022-04-15",
        "origin": "MDZ",
        "destination": "COR",
        "price": 445.51,
        "availability": 3
    },
    {
        "data": "2022-04-15",
        "origin": "BRC",
        "destination": "COR",
        "price": 373.62,
        "availability": 2
    },
    {
        "data": "2022-04-15",
        "origin": "BRC",
        "destination": "EPA",
        "price": 171.44,
        "availability": 2
    },
    {
        "data": "2022-01-27",
        "origin": "MDZ",
        "destination": "COR",
        "price": 296.47,
        "availability": 1
    },
    {
        "data": "2022-01-27",
        "origin": "BRC",
        "destination": "COR",
        "price": 217.3,
        "availability": 7
    },
    {
        "data": "2022-01-27",
        "origin": "BRC",
        "destination": "EPA",
        "price": 211.04,
        "availability": 7
    },
    {
        "data": "2022-04-28",
        "origin": "MDZ",
        "destination": "COR",
        "price": 349.5,
        "availability": 6
    },
    {
        "data": "2022-04-28",
        "origin": "BRC",
        "destination": "COR",
        "price": 363.66,
        "availability": 3
    },
    {
        "data": "2022-04-28",
        "origin": "BRC",
        "destination": "EPA",
        "price": 409.26,
        "availability": 6
    },
    {
        "data": "2022-03-17",
        "origin": "MDZ",
        "destination": "COR",
        "price": 370.72,
        "availability": 7
    },
    {
        "data": "2022-03-17",
        "origin": "BRC",
        "destination": "COR",
        "price": 478.95,
        "availability": 6
    },
    {
        "data": "2022-03-17",
        "origin": "BRC",
        "destination": "EPA",
        "price": 495.92,
        "availability": 2
    },
    {
        "data": "2022-04-14",
        "origin": "MDZ",
        "destination": "COR",
        "price": 224.06,
        "availability": 5
    },
    {
        "data": "2022-04-14",
        "origin": "BRC",
        "destination": "COR",
        "price": 377.22,
        "availability": 5
    },
    {
        "data": "2022-04-14",
        "origin": "BRC",
        "destination": "EPA",
        "price": 364.45,
        "availability": 3
    },
    {
        "data": "2022-02-08",
        "origin": "MDZ",
        "destination": "COR",
        "price": 453.33,
        "availability": 9
    },
    {
        "data": "2022-02-08",
        "origin": "BRC",
        "destination": "COR",
        "price": 182.19,
        "availability": 8
    },
    {
        "data": "2022-02-08",
        "origin": "BRC",
        "destination": "EPA",
        "price": 389.19,
        "availability": 1
    },
    {
        "data": "2022-04-29",
        "origin": "MDZ",
        "destination": "COR",
        "price": 427.98,
        "availability": 7
    },
    {
        "data": "2022-04-29",
        "origin": "BRC",
        "destination": "COR",
        "price": 364.35,
        "availability": 2
    },
    {
        "data": "2022-04-29",
        "origin": "BRC",
        "destination": "EPA",
        "price": 432.94,
        "availability": 6
    },
    {
        "data": "2022-03-07",
        "origin": "MDZ",
        "destination": "COR",
        "price": 407.47,
        "availability": 2
    },
    {
        "data": "2022-03-07",
        "origin": "BRC",
        "destination": "COR",
        "price": 423.14,
        "availability": 1
    },
    {
        "data": "2022-03-07",
        "origin": "BRC",
        "destination": "EPA",
        "price": 397.22,
        "availability": 7
    },
    {
        "data": "2022-04-19",
        "origin": "MDZ",
        "destination": "COR",
        "price": 238.68,
        "availability": 2
    },
    {
        "data": "2022-04-19",
        "origin": "BRC",
        "destination": "COR",
        "price": 297.9,
        "availability": 9
    },
    {
        "data": "2022-04-19",
        "origin": "BRC",
        "destination": "EPA",
        "price": 498.95,
        "availability": 9
    },
    {
        "data": "2022-02-05",
        "origin": "MDZ",
        "destination": "COR",
        "price": 490.96,
        "availability": 5
    },
    {
        "data": "2022-02-05",
        "origin": "BRC",
        "destination": "COR",
        "price": 332.97,
        "availability": 6
    },
    {
        "data": "2022-02-05",
        "origin": "BRC",
        "destination": "EPA",
        "price": 167.35,
        "availability": 6
    },
    {
        "data": "2022-05-03",
        "origin": "MDZ",
        "destination": "COR",
        "price": 223.08,
        "availability": 1
    },
    {
        "data": "2022-05-03",
        "origin": "BRC",
        "destination": "COR",
        "price": 307.35,
        "availability": 1
    },
    {
        "data": "2022-05-03",
        "origin": "BRC",
        "destination": "EPA",
        "price": 240.16,
        "availability": 1
    },
    {
        "data": "2022-03-25",
        "origin": "MDZ",
        "destination": "COR",
        "price": 489.75,
        "availability": 1
    },
    {
        "data": "2022-03-25",
        "origin": "BRC",
        "destination": "COR",
        "price": 426.58,
        "availability": 8
    },
    {
        "data": "2022-03-25",
        "origin": "BRC",
        "destination": "EPA",
        "price": 428.47,
        "availability": 6
    },
    {
        "data": "2022-04-18",
        "origin": "MDZ",
        "destination": "COR",
        "price": 335.48,
        "availability": 7
    },
    {
        "data": "2022-04-18",
        "origin": "BRC",
        "destination": "COR",
        "price": 171.41,
        "availability": 3
    },
    {
        "data": "2022-04-18",
        "origin": "BRC",
        "destination": "EPA",
        "price": 351.29,
        "availability": 3
    },
    {
        "data": "2022-02-15",
        "origin": "MDZ",
        "destination": "COR",
        "price": 452.92,
        "availability": 5
    },
    {
        "data": "2022-02-15",
        "origin": "BRC",
        "destination": "COR",
        "price": 456.88,
        "availability": 3
    },
    {
        "data": "2022-02-15",
        "origin": "BRC",
        "destination": "EPA",
        "price": 270.88,
        "availability": 4
    },
    {
        "data": "2022-05-02",
        "origin": "MDZ",
        "destination": "COR",
        "price": 314.06,
        "availability": 2
    },
    {
        "data": "2022-05-02",
        "origin": "BRC",
        "destination": "COR",
        "price": 499.86,
        "availability": 1
    },
    {
        "data": "2022-05-02",
        "origin": "BRC",
        "destination": "EPA",
        "price": 340.37,
        "availability": 6
    },
    {
        "data": "2022-03-16",
        "origin": "MDZ",
        "destination": "COR",
        "price": 453.18,
        "availability": 6
    },
    {
        "data": "2022-03-16",
        "origin": "BRC",
        "destination": "COR",
        "price": 454.46,
        "availability": 3
    },
    {
        "data": "2022-03-16",
        "origin": "BRC",
        "destination": "EPA",
        "price": 237.23,
        "availability": 1
    },
    {
        "data": "2022-04-27",
        "origin": "MDZ",
        "destination": "COR",
        "price": 160.03,
        "availability": 6
    },
    {
        "data": "2022-04-27",
        "origin": "BRC",
        "destination": "COR",
        "price": 412.09,
        "availability": 7
    },
    {
        "data": "2022-04-27",
        "origin": "BRC",
        "destination": "EPA",
        "price": 394.48,
        "availability": 1
    },
    {
        "data": "2022-02-09",
        "origin": "MDZ",
        "destination": "COR",
        "price": 444.79,
        "availability": 1
    },
    {
        "data": "2022-02-09",
        "origin": "BRC",
        "destination": "COR",
        "price": 189.69,
        "availability": 5
    },
    {
        "data": "2022-02-09",
        "origin": "BRC",
        "destination": "EPA",
        "price": 301.96,
        "availability": 2
    },
    {
        "data": "2022-04-26",
        "origin": "MDZ",
        "destination": "COR",
        "price": 186.99,
        "availability": 4
    },
    {
        "data": "2022-04-26",
        "origin": "BRC",
        "destination": "COR",
        "price": 498.52,
        "availability": 9
    },
    {
        "data": "2022-04-26",
        "origin": "BRC",
        "destination": "EPA",
        "price": 285.79,
        "availability": 5
    },
    {
        "data": "2022-02-19",
        "origin": "MDZ",
        "destination": "COR",
        "price": 319.7,
        "availability": 7
    },
    {
        "data": "2022-02-19",
        "origin": "BRC",
        "destination": "COR",
        "price": 470.92,
        "availability": 9
    },
    {
        "data": "2022-02-19",
        "origin": "BRC",
        "destination": "EPA",
        "price": 495.15,
        "availability": 8
    },
    {
        "data": "2022-03-24",
        "origin": "MDZ",
        "destination": "COR",
        "price": 376.6,
        "availability": 8
    },
    {
        "data": "2022-03-24",
        "origin": "BRC",
        "destination": "COR",
        "price": 452.16,
        "availability": 4
    },
    {
        "data": "2022-03-24",
        "origin": "BRC",
        "destination": "EPA",
        "price": 444.19,
        "availability": 2
    },
    {
        "data": "2022-05-01",
        "origin": "MDZ",
        "destination": "COR",
        "price": 270.43,
        "availability": 5
    },
    {
        "data": "2022-05-01",
        "origin": "BRC",
        "destination": "COR",
        "price": 310.51,
        "availability": 4
    },
    {
        "data": "2022-05-01",
        "origin": "BRC",
        "destination": "EPA",
        "price": 244.72,
        "availability": 5
    },
    {
        "data": "2022-02-21",
        "origin": "MDZ",
        "destination": "COR",
        "price": 454.47,
        "availability": 1
    },
    {
        "data": "2022-02-21",
        "origin": "BRC",
        "destination": "COR",
        "price": 439.74,
        "availability": 5
    },
    {
        "data": "2022-02-21",
        "origin": "BRC",
        "destination": "EPA",
        "price": 310.23,
        "availability": 7
    },
    {
        "data": "2022-03-29",
        "origin": "MDZ",
        "destination": "COR",
        "price": 171.77,
        "availability": 4
    },
    {
        "data": "2022-03-29",
        "origin": "BRC",
        "destination": "COR",
        "price": 202.33,
        "availability": 8
    },
    {
        "data": "2022-03-29",
        "origin": "BRC",
        "destination": "EPA",
        "price": 404.14,
        "availability": 8
    },
    {
        "data": "2022-03-28",
        "origin": "MDZ",
        "destination": "COR",
        "price": 461.07,
        "availability": 7
    },
    {
        "data": "2022-03-28",
        "origin": "BRC",
        "destination": "COR",
        "price": 436.15,
        "availability": 4
    },
    {
        "data": "2022-03-28",
        "origin": "BRC",
        "destination": "EPA",
        "price": 336.08,
        "availability": 5
    },
    {
        "data": "2022-02-14",
        "origin": "MDZ",
        "destination": "COR",
        "price": 246.97,
        "availability": 3
    },
    {
        "data": "2022-02-14",
        "origin": "BRC",
        "destination": "COR",
        "price": 263.27,
        "availability": 8
    },
    {
        "data": "2022-02-14",
        "origin": "BRC",
        "destination": "EPA",
        "price": 222.84,
        "availability": 3
    },
    {
        "data": "2022-03-04",
        "origin": "MDZ",
        "destination": "COR",
        "price": 299.4,
        "availability": 9
    },
    {
        "data": "2022-03-04",
        "origin": "BRC",
        "destination": "COR",
        "price": 243.23,
        "availability": 8
    },
    {
        "data": "2022-03-04",
        "origin": "BRC",
        "destination": "EPA",
        "price": 168.32,
        "availability": 6
    },
    {
        "data": "2022-04-02",
        "origin": "MDZ",
        "destination": "COR",
        "price": 225.55,
        "availability": 8
    },
    {
        "data": "2022-04-02",
        "origin": "BRC",
        "destination": "COR",
        "price": 498.37,
        "availability": 2
    },
    {
        "data": "2022-04-02",
        "origin": "BRC",
        "destination": "EPA",
        "price": 286.72,
        "availability": 5
    },
    {
        "data": "2022-04-03",
        "origin": "MDZ",
        "destination": "COR",
        "price": 153.61,
        "availability": 8
    },
    {
        "data": "2022-04-03",
        "origin": "BRC",
        "destination": "COR",
        "price": 202.87,
        "availability": 3
    },
    {
        "data": "2022-04-03",
        "origin": "BRC",
        "destination": "EPA",
        "price": 253.68,
        "availability": 6
    },
    {
        "data": "2022-02-18",
        "origin": "MDZ",
        "destination": "COR",
        "price": 170.07,
        "availability": 9
    },
    {
        "data": "2022-02-18",
        "origin": "BRC",
        "destination": "COR",
        "price": 482.97,
        "availability": 1
    },
    {
        "data": "2022-02-18",
        "origin": "BRC",
        "destination": "EPA",
        "price": 469.49,
        "availability": 3
    },
    {
        "data": "2022-03-08",
        "origin": "MDZ",
        "destination": "COR",
        "price": 280.12,
        "availability": 9
    },
    {
        "data": "2022-03-08",
        "origin": "BRC",
        "destination": "COR",
        "price": 207.43,
        "availability": 4
    },
    {
        "data": "2022-03-08",
        "origin": "BRC",
        "destination": "EPA",
        "price": 266.12,
        "availability": 8
    },
    {
        "data": "2022-04-13",
        "origin": "MDZ",
        "destination": "COR",
        "price": 153.23,
        "availability": 6
    },
    {
        "data": "2022-04-13",
        "origin": "BRC",
        "destination": "COR",
        "price": 475.35,
        "availability": 6
    },
    {
        "data": "2022-04-13",
        "origin": "BRC",
        "destination": "EPA",
        "price": 288.39,
        "availability": 8
    },
    {
        "data": "2022-04-12",
        "origin": "MDZ",
        "destination": "COR",
        "price": 345.07,
        "availability": 1
    },
    {
        "data": "2022-04-12",
        "origin": "BRC",
        "destination": "COR",
        "price": 402.91,
        "availability": 2
    },
    {
        "data": "2022-04-12",
        "origin": "BRC",
        "destination": "EPA",
        "price": 210.1,
        "availability": 7
    },
    {
        "data": "2022-02-20",
        "origin": "MDZ",
        "destination": "COR",
        "price": 443.08,
        "availability": 4
    },
    {
        "data": "2022-02-20",
        "origin": "BRC",
        "destination": "COR",
        "price": 288.05,
        "availability": 3
    },
    {
        "data": "2022-02-20",
        "origin": "BRC",
        "destination": "EPA",
        "price": 271.66,
        "availability": 5
    },
    {
        "data": "2022-03-15",
        "origin": "MDZ",
        "destination": "COR",
        "price": 214.85,
        "availability": 9
    },
    {
        "data": "2022-03-15",
        "origin": "BRC",
        "destination": "COR",
        "price": 275.13,
        "availability": 1
    },
    {
        "data": "2022-03-15",
        "origin": "BRC",
        "destination": "EPA",
        "price": 331.87,
        "availability": 1
    },
    {
        "data": "2022-04-20",
        "origin": "MDZ",
        "destination": "COR",
        "price": 251.88,
        "availability": 7
    },
    {
        "data": "2022-04-20",
        "origin": "BRC",
        "destination": "COR",
        "price": 318.13,
        "availability": 9
    },
    {
        "data": "2022-04-20",
        "origin": "BRC",
        "destination": "EPA",
        "price": 179.02,
        "availability": 7
    },
    {
        "data": "2022-04-21",
        "origin": "MDZ",
        "destination": "COR",
        "price": 457.14,
        "availability": 3
    },
    {
        "data": "2022-04-21",
        "origin": "BRC",
        "destination": "COR",
        "price": 260.2,
        "availability": 3
    },
    {
        "data": "2022-04-21",
        "origin": "BRC",
        "destination": "EPA",
        "price": 249.97,
        "availability": 2
    },
    {
        "data": "2022-03-05",
        "origin": "MDZ",
        "destination": "COR",
        "price": 164.18,
        "availability": 8
    },
    {
        "data": "2022-03-05",
        "origin": "BRC",
        "destination": "COR",
        "price": 333.92,
        "availability": 1
    },
    {
        "data": "2022-03-05",
        "origin": "BRC",
        "destination": "EPA",
        "price": 423.2,
        "availability": 3
    },
    {
        "data": "2022-03-19",
        "origin": "MDZ",
        "destination": "COR",
        "price": 428.61,
        "availability": 7
    },
    {
        "data": "2022-03-19",
        "origin": "BRC",
        "destination": "COR",
        "price": 364.88,
        "availability": 3
    },
    {
        "data": "2022-03-19",
        "origin": "BRC",
        "destination": "EPA",
        "price": 370.24,
        "availability": 9
    },
    {
        "data": "2022-05-05",
        "origin": "MDZ",
        "destination": "COR",
        "price": 463.62,
        "availability": 1
    },
    {
        "data": "2022-05-05",
        "origin": "BRC",
        "destination": "COR",
        "price": 465.95,
        "availability": 9
    },
    {
        "data": "2022-05-05",
        "origin": "BRC",
        "destination": "EPA",
        "price": 492.09,
        "availability": 9
    },
    {
        "data": "2022-04-30",
        "origin": "MDZ",
        "destination": "COR",
        "price": 205.69,
        "availability": 1
    },
    {
        "data": "2022-04-30",
        "origin": "BRC",
        "destination": "COR",
        "price": 425.36,
        "availability": 1
    },
    {
        "data": "2022-04-30",
        "origin": "BRC",
        "destination": "EPA",
        "price": 396.39,
        "availability": 6
    },
    {
        "data": "2022-03-09",
        "origin": "MDZ",
        "destination": "COR",
        "price": 463.2,
        "availability": 2
    },
    {
        "data": "2022-03-09",
        "origin": "BRC",
        "destination": "COR",
        "price": 201.59,
        "availability": 1
    },
    {
        "data": "2022-03-09",
        "origin": "BRC",
        "destination": "EPA",
        "price": 196.34,
        "availability": 9
    },
    {
        "data": "2022-03-26",
        "origin": "MDZ",
        "destination": "COR",
        "price": 374.97,
        "availability": 2
    },
    {
        "data": "2022-03-26",
        "origin": "BRC",
        "destination": "COR",
        "price": 312.66,
        "availability": 6
    },
    {
        "data": "2022-03-26",
        "origin": "BRC",
        "destination": "EPA",
        "price": 183.34,
        "availability": 9
    },
    {
        "data": "2022-03-14",
        "origin": "MDZ",
        "destination": "COR",
        "price": 492.09,
        "availability": 2
    },
    {
        "data": "2022-03-14",
        "origin": "BRC",
        "destination": "COR",
        "price": 250.5,
        "availability": 8
    },
    {
        "data": "2022-03-14",
        "origin": "BRC",
        "destination": "EPA",
        "price": 271.71,
        "availability": 2
    },
    {
        "data": "2022-04-01",
        "origin": "MDZ",
        "destination": "COR",
        "price": 398,
        "availability": 2
    },
    {
        "data": "2022-04-01",
        "origin": "BRC",
        "destination": "COR",
        "price": 210.09,
        "availability": 5
    },
    {
        "data": "2022-04-01",
        "origin": "BRC",
        "destination": "EPA",
        "price": 208.8,
        "availability": 9
    },
    {
        "data": "2022-05-04",
        "origin": "MDZ",
        "destination": "COR",
        "price": 471.76,
        "availability": 9
    },
    {
        "data": "2022-05-04",
        "origin": "BRC",
        "destination": "COR",
        "price": 450.97,
        "availability": 1
    },
    {
        "data": "2022-05-04",
        "origin": "BRC",
        "destination": "EPA",
        "price": 215.42,
        "availability": 5
    },
    {
        "data": "2022-03-18",
        "origin": "MDZ",
        "destination": "COR",
        "price": 429.74,
        "availability": 4
    },
    {
        "data": "2022-03-18",
        "origin": "BRC",
        "destination": "COR",
        "price": 421.78,
        "availability": 6
    },
    {
        "data": "2022-03-18",
        "origin": "BRC",
        "destination": "EPA",
        "price": 364.43,
        "availability": 2
    },
    {
        "data": "2022-04-10",
        "origin": "MDZ",
        "destination": "COR",
        "price": 307.28,
        "availability": 1
    },
    {
        "data": "2022-04-10",
        "origin": "BRC",
        "destination": "COR",
        "price": 151.85,
        "availability": 5
    },
    {
        "data": "2022-04-10",
        "origin": "BRC",
        "destination": "EPA",
        "price": 203.61,
        "availability": 2
    },
    {
        "data": "2022-03-27",
        "origin": "MDZ",
        "destination": "COR",
        "price": 321.32,
        "availability": 9
    },
    {
        "data": "2022-03-27",
        "origin": "BRC",
        "destination": "COR",
        "price": 390.46,
        "availability": 6
    },
    {
        "data": "2022-03-27",
        "origin": "BRC",
        "destination": "EPA",
        "price": 385.77,
        "availability": 6
    },
    {
        "data": "2022-04-22",
        "origin": "MDZ",
        "destination": "COR",
        "price": 174.19,
        "availability": 6
    },
    {
        "data": "2022-04-22",
        "origin": "BRC",
        "destination": "COR",
        "price": 396.52,
        "availability": 5
    },
    {
        "data": "2022-04-22",
        "origin": "BRC",
        "destination": "EPA",
        "price": 408.31,
        "availability": 6
    },
    {
        "data": "2022-04-11",
        "origin": "MDZ",
        "destination": "COR",
        "price": 189.68,
        "availability": 3
    },
    {
        "data": "2022-04-11",
        "origin": "BRC",
        "destination": "COR",
        "price": 276.17,
        "availability": 5
    },
    {
        "data": "2022-04-11",
        "origin": "BRC",
        "destination": "EPA",
        "price": 190.55,
        "availability": 1
    },
    {
        "data": "2022-05-06",
        "origin": "MDZ",
        "destination": "COR",
        "price": 316.47,
        "availability": 4
    },
    {
        "data": "2022-05-06",
        "origin": "BRC",
        "destination": "COR",
        "price": 469.6,
        "availability": 6
    },
    {
        "data": "2022-05-06",
        "origin": "BRC",
        "destination": "EPA",
        "price": 321.23,
        "availability": 7
    },
    {
        "data": "2022-04-23",
        "origin": "MDZ",
        "destination": "COR",
        "price": 356.62,
        "availability": 1
    },
    {
        "data": "2022-04-23",
        "origin": "BRC",
        "destination": "COR",
        "price": 202.3,
        "availability": 6
    },
    {
        "data": "2022-04-23",
        "origin": "BRC",
        "destination": "EPA",
        "price": 271.38,
        "availability": 7
    }
]
))}

    export default api;